var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: (newValue) => all[name] = () => newValue
    });
};

// lib/fp.js
var exports_fp = {};
__export(exports_fp, {
  yearsToQuarters: () => yearsToQuarters3,
  yearsToMonths: () => yearsToMonths3,
  yearsToDays: () => yearsToDays3,
  weeksToDays: () => weeksToDays3,
  transpose: () => transpose4,
  toDate: () => toDate108,
  subYearsWithOptions: () => subYearsWithOptions,
  subYears: () => subYears3,
  subWithOptions: () => subWithOptions,
  subWeeksWithOptions: () => subWeeksWithOptions,
  subWeeks: () => subWeeks3,
  subSecondsWithOptions: () => subSecondsWithOptions,
  subSeconds: () => subSeconds3,
  subQuartersWithOptions: () => subQuartersWithOptions,
  subQuarters: () => subQuarters3,
  subMonthsWithOptions: () => subMonthsWithOptions,
  subMonths: () => subMonths4,
  subMinutesWithOptions: () => subMinutesWithOptions,
  subMinutes: () => subMinutes3,
  subMillisecondsWithOptions: () => subMillisecondsWithOptions,
  subMilliseconds: () => subMilliseconds3,
  subISOWeekYearsWithOptions: () => subISOWeekYearsWithOptions,
  subISOWeekYears: () => subISOWeekYears4,
  subHoursWithOptions: () => subHoursWithOptions,
  subHours: () => subHours3,
  subDaysWithOptions: () => subDaysWithOptions,
  subDays: () => subDays5,
  subBusinessDaysWithOptions: () => subBusinessDaysWithOptions,
  subBusinessDays: () => subBusinessDays3,
  sub: () => sub3,
  startOfYearWithOptions: () => startOfYearWithOptions,
  startOfYear: () => startOfYear5,
  startOfWeekYearWithOptions: () => startOfWeekYearWithOptions,
  startOfWeekYear: () => startOfWeekYear5,
  startOfWeekWithOptions: () => startOfWeekWithOptions,
  startOfWeek: () => startOfWeek12,
  startOfSecondWithOptions: () => startOfSecondWithOptions,
  startOfSecond: () => startOfSecond4,
  startOfQuarterWithOptions: () => startOfQuarterWithOptions,
  startOfQuarter: () => startOfQuarter5,
  startOfMonthWithOptions: () => startOfMonthWithOptions,
  startOfMonth: () => startOfMonth6,
  startOfMinuteWithOptions: () => startOfMinuteWithOptions,
  startOfMinute: () => startOfMinute4,
  startOfISOWeekYearWithOptions: () => startOfISOWeekYearWithOptions,
  startOfISOWeekYear: () => startOfISOWeekYear7,
  startOfISOWeekWithOptions: () => startOfISOWeekWithOptions,
  startOfISOWeek: () => startOfISOWeek11,
  startOfHourWithOptions: () => startOfHourWithOptions,
  startOfHour: () => startOfHour4,
  startOfDecadeWithOptions: () => startOfDecadeWithOptions,
  startOfDecade: () => startOfDecade3,
  startOfDayWithOptions: () => startOfDayWithOptions,
  startOfDay: () => startOfDay5,
  setYearWithOptions: () => setYearWithOptions,
  setYear: () => setYear3,
  setWithOptions: () => setWithOptions,
  setWeekYearWithOptions: () => setWeekYearWithOptions,
  setWeekYear: () => setWeekYear3,
  setWeekWithOptions: () => setWeekWithOptions,
  setWeek: () => setWeek4,
  setSecondsWithOptions: () => setSecondsWithOptions,
  setSeconds: () => setSeconds3,
  setQuarterWithOptions: () => setQuarterWithOptions,
  setQuarter: () => setQuarter3,
  setMonthWithOptions: () => setMonthWithOptions,
  setMonth: () => setMonth4,
  setMinutesWithOptions: () => setMinutesWithOptions,
  setMinutes: () => setMinutes3,
  setMillisecondsWithOptions: () => setMillisecondsWithOptions,
  setMilliseconds: () => setMilliseconds3,
  setISOWeekYearWithOptions: () => setISOWeekYearWithOptions,
  setISOWeekYear: () => setISOWeekYear4,
  setISOWeekWithOptions: () => setISOWeekWithOptions,
  setISOWeek: () => setISOWeek4,
  setISODayWithOptions: () => setISODayWithOptions,
  setISODay: () => setISODay4,
  setHoursWithOptions: () => setHoursWithOptions,
  setHours: () => setHours3,
  setDayWithOptions: () => setDayWithOptions,
  setDayOfYearWithOptions: () => setDayOfYearWithOptions,
  setDayOfYear: () => setDayOfYear3,
  setDay: () => setDay6,
  setDateWithOptions: () => setDateWithOptions,
  setDate: () => setDate3,
  set: () => set3,
  secondsToMinutes: () => secondsToMinutes3,
  secondsToMilliseconds: () => secondsToMilliseconds3,
  secondsToHours: () => secondsToHours3,
  roundToNearestMinutesWithOptions: () => roundToNearestMinutesWithOptions,
  roundToNearestMinutes: () => roundToNearestMinutes3,
  roundToNearestHoursWithOptions: () => roundToNearestHoursWithOptions,
  roundToNearestHours: () => roundToNearestHours3,
  quartersToYears: () => quartersToYears3,
  quartersToMonths: () => quartersToMonths3,
  previousWednesdayWithOptions: () => previousWednesdayWithOptions,
  previousWednesday: () => previousWednesday3,
  previousTuesdayWithOptions: () => previousTuesdayWithOptions,
  previousTuesday: () => previousTuesday3,
  previousThursdayWithOptions: () => previousThursdayWithOptions,
  previousThursday: () => previousThursday3,
  previousSundayWithOptions: () => previousSundayWithOptions,
  previousSunday: () => previousSunday3,
  previousSaturdayWithOptions: () => previousSaturdayWithOptions,
  previousSaturday: () => previousSaturday3,
  previousMondayWithOptions: () => previousMondayWithOptions,
  previousMonday: () => previousMonday3,
  previousFridayWithOptions: () => previousFridayWithOptions,
  previousFriday: () => previousFriday3,
  previousDayWithOptions: () => previousDayWithOptions,
  previousDay: () => previousDay3,
  parseWithOptions: () => parseWithOptions,
  parseJSONWithOptions: () => parseJSONWithOptions,
  parseJSON: () => parseJSON3,
  parseISOWithOptions: () => parseISOWithOptions,
  parseISO: () => parseISO3,
  parse: () => parse4,
  nextWednesdayWithOptions: () => nextWednesdayWithOptions,
  nextWednesday: () => nextWednesday3,
  nextTuesdayWithOptions: () => nextTuesdayWithOptions,
  nextTuesday: () => nextTuesday3,
  nextThursdayWithOptions: () => nextThursdayWithOptions,
  nextThursday: () => nextThursday3,
  nextSundayWithOptions: () => nextSundayWithOptions,
  nextSunday: () => nextSunday3,
  nextSaturdayWithOptions: () => nextSaturdayWithOptions,
  nextSaturday: () => nextSaturday3,
  nextMondayWithOptions: () => nextMondayWithOptions,
  nextMonday: () => nextMonday3,
  nextFridayWithOptions: () => nextFridayWithOptions,
  nextFriday: () => nextFriday3,
  nextDayWithOptions: () => nextDayWithOptions,
  nextDay: () => nextDay3,
  monthsToYears: () => monthsToYears3,
  monthsToQuarters: () => monthsToQuarters3,
  minutesToSeconds: () => minutesToSeconds3,
  minutesToMilliseconds: () => minutesToMilliseconds3,
  minutesToHours: () => minutesToHours3,
  minWithOptions: () => minWithOptions,
  min: () => min4,
  millisecondsToSeconds: () => millisecondsToSeconds3,
  millisecondsToMinutes: () => millisecondsToMinutes3,
  millisecondsToHours: () => millisecondsToHours3,
  milliseconds: () => milliseconds3,
  maxWithOptions: () => maxWithOptions,
  max: () => max4,
  lightFormat: () => lightFormat3,
  lastDayOfYearWithOptions: () => lastDayOfYearWithOptions,
  lastDayOfYear: () => lastDayOfYear3,
  lastDayOfWeekWithOptions: () => lastDayOfWeekWithOptions,
  lastDayOfWeek: () => lastDayOfWeek4,
  lastDayOfQuarterWithOptions: () => lastDayOfQuarterWithOptions,
  lastDayOfQuarter: () => lastDayOfQuarter3,
  lastDayOfMonthWithOptions: () => lastDayOfMonthWithOptions,
  lastDayOfMonth: () => lastDayOfMonth4,
  lastDayOfISOWeekYearWithOptions: () => lastDayOfISOWeekYearWithOptions,
  lastDayOfISOWeekYear: () => lastDayOfISOWeekYear3,
  lastDayOfISOWeekWithOptions: () => lastDayOfISOWeekWithOptions,
  lastDayOfISOWeek: () => lastDayOfISOWeek3,
  lastDayOfDecadeWithOptions: () => lastDayOfDecadeWithOptions,
  lastDayOfDecade: () => lastDayOfDecade3,
  isWithinIntervalWithOptions: () => isWithinIntervalWithOptions,
  isWithinInterval: () => isWithinInterval3,
  isWeekendWithOptions: () => isWeekendWithOptions,
  isWeekend: () => isWeekend6,
  isWednesdayWithOptions: () => isWednesdayWithOptions,
  isWednesday: () => isWednesday3,
  isValid: () => isValid9,
  isTuesdayWithOptions: () => isTuesdayWithOptions,
  isTuesday: () => isTuesday3,
  isThursdayWithOptions: () => isThursdayWithOptions,
  isThursday: () => isThursday3,
  isSundayWithOptions: () => isSundayWithOptions,
  isSunday: () => isSunday4,
  isSaturdayWithOptions: () => isSaturdayWithOptions,
  isSaturday: () => isSaturday4,
  isSameYearWithOptions: () => isSameYearWithOptions,
  isSameYear: () => isSameYear3,
  isSameWeekWithOptions: () => isSameWeekWithOptions,
  isSameWeek: () => isSameWeek4,
  isSameSecond: () => isSameSecond3,
  isSameQuarterWithOptions: () => isSameQuarterWithOptions,
  isSameQuarter: () => isSameQuarter3,
  isSameMonthWithOptions: () => isSameMonthWithOptions,
  isSameMonth: () => isSameMonth3,
  isSameMinute: () => isSameMinute3,
  isSameISOWeekYearWithOptions: () => isSameISOWeekYearWithOptions,
  isSameISOWeekYear: () => isSameISOWeekYear3,
  isSameISOWeekWithOptions: () => isSameISOWeekWithOptions,
  isSameISOWeek: () => isSameISOWeek3,
  isSameHourWithOptions: () => isSameHourWithOptions,
  isSameHour: () => isSameHour3,
  isSameDayWithOptions: () => isSameDayWithOptions,
  isSameDay: () => isSameDay4,
  isMondayWithOptions: () => isMondayWithOptions,
  isMonday: () => isMonday3,
  isMatchWithOptions: () => isMatchWithOptions,
  isMatch: () => isMatch3,
  isLeapYearWithOptions: () => isLeapYearWithOptions,
  isLeapYear: () => isLeapYear4,
  isLastDayOfMonthWithOptions: () => isLastDayOfMonthWithOptions,
  isLastDayOfMonth: () => isLastDayOfMonth4,
  isFridayWithOptions: () => isFridayWithOptions,
  isFriday: () => isFriday3,
  isFirstDayOfMonthWithOptions: () => isFirstDayOfMonthWithOptions,
  isFirstDayOfMonth: () => isFirstDayOfMonth3,
  isExists: () => isExists3,
  isEqual: () => isEqual3,
  isDate: () => isDate4,
  isBefore: () => isBefore3,
  isAfter: () => isAfter3,
  intlFormatDistanceWithOptions: () => intlFormatDistanceWithOptions,
  intlFormatDistance: () => intlFormatDistance3,
  intlFormat: () => intlFormat3,
  intervalWithOptions: () => intervalWithOptions,
  intervalToDurationWithOptions: () => intervalToDurationWithOptions,
  intervalToDuration: () => intervalToDuration3,
  interval: () => interval3,
  hoursToSeconds: () => hoursToSeconds3,
  hoursToMinutes: () => hoursToMinutes3,
  hoursToMilliseconds: () => hoursToMilliseconds3,
  getYearWithOptions: () => getYearWithOptions,
  getYear: () => getYear3,
  getWeeksInMonthWithOptions: () => getWeeksInMonthWithOptions,
  getWeeksInMonth: () => getWeeksInMonth3,
  getWeekYearWithOptions: () => getWeekYearWithOptions,
  getWeekYear: () => getWeekYear5,
  getWeekWithOptions: () => getWeekWithOptions,
  getWeekOfMonthWithOptions: () => getWeekOfMonthWithOptions,
  getWeekOfMonth: () => getWeekOfMonth3,
  getWeek: () => getWeek4,
  getUnixTime: () => getUnixTime3,
  getTime: () => getTime3,
  getSeconds: () => getSeconds3,
  getQuarterWithOptions: () => getQuarterWithOptions,
  getQuarter: () => getQuarter4,
  getOverlappingDaysInIntervals: () => getOverlappingDaysInIntervals3,
  getMonthWithOptions: () => getMonthWithOptions,
  getMonth: () => getMonth3,
  getMinutesWithOptions: () => getMinutesWithOptions,
  getMinutes: () => getMinutes3,
  getMilliseconds: () => getMilliseconds3,
  getISOWeeksInYearWithOptions: () => getISOWeeksInYearWithOptions,
  getISOWeeksInYear: () => getISOWeeksInYear3,
  getISOWeekYearWithOptions: () => getISOWeekYearWithOptions,
  getISOWeekYear: () => getISOWeekYear8,
  getISOWeekWithOptions: () => getISOWeekWithOptions,
  getISOWeek: () => getISOWeek4,
  getISODayWithOptions: () => getISODayWithOptions,
  getISODay: () => getISODay3,
  getHoursWithOptions: () => getHoursWithOptions,
  getHours: () => getHours3,
  getDecadeWithOptions: () => getDecadeWithOptions,
  getDecade: () => getDecade3,
  getDaysInYearWithOptions: () => getDaysInYearWithOptions,
  getDaysInYear: () => getDaysInYear3,
  getDaysInMonthWithOptions: () => getDaysInMonthWithOptions,
  getDaysInMonth: () => getDaysInMonth3,
  getDayWithOptions: () => getDayWithOptions,
  getDayOfYearWithOptions: () => getDayOfYearWithOptions,
  getDayOfYear: () => getDayOfYear4,
  getDay: () => getDay3,
  getDateWithOptions: () => getDateWithOptions,
  getDate: () => getDate3,
  fromUnixTimeWithOptions: () => fromUnixTimeWithOptions,
  fromUnixTime: () => fromUnixTime3,
  formatWithOptions: () => formatWithOptions,
  formatRelativeWithOptions: () => formatRelativeWithOptions,
  formatRelative: () => formatRelative5,
  formatRFC7231: () => formatRFC72313,
  formatRFC3339WithOptions: () => formatRFC3339WithOptions,
  formatRFC3339: () => formatRFC33393,
  formatISOWithOptions: () => formatISOWithOptions,
  formatISODuration: () => formatISODuration3,
  formatISO9075WithOptions: () => formatISO9075WithOptions,
  formatISO9075: () => formatISO90753,
  formatISO: () => formatISO3,
  formatDurationWithOptions: () => formatDurationWithOptions,
  formatDuration: () => formatDuration3,
  formatDistanceWithOptions: () => formatDistanceWithOptions,
  formatDistanceStrictWithOptions: () => formatDistanceStrictWithOptions,
  formatDistanceStrict: () => formatDistanceStrict3,
  formatDistance: () => formatDistance5,
  format: () => format3,
  endOfYearWithOptions: () => endOfYearWithOptions,
  endOfYear: () => endOfYear4,
  endOfWeekWithOptions: () => endOfWeekWithOptions,
  endOfWeek: () => endOfWeek4,
  endOfSecondWithOptions: () => endOfSecondWithOptions,
  endOfSecond: () => endOfSecond3,
  endOfQuarterWithOptions: () => endOfQuarterWithOptions,
  endOfQuarter: () => endOfQuarter3,
  endOfMonthWithOptions: () => endOfMonthWithOptions,
  endOfMonth: () => endOfMonth5,
  endOfMinuteWithOptions: () => endOfMinuteWithOptions,
  endOfMinute: () => endOfMinute3,
  endOfISOWeekYearWithOptions: () => endOfISOWeekYearWithOptions,
  endOfISOWeekYear: () => endOfISOWeekYear3,
  endOfISOWeekWithOptions: () => endOfISOWeekWithOptions,
  endOfISOWeek: () => endOfISOWeek3,
  endOfHourWithOptions: () => endOfHourWithOptions,
  endOfHour: () => endOfHour3,
  endOfDecadeWithOptions: () => endOfDecadeWithOptions,
  endOfDecade: () => endOfDecade3,
  endOfDayWithOptions: () => endOfDayWithOptions,
  endOfDay: () => endOfDay4,
  eachYearOfIntervalWithOptions: () => eachYearOfIntervalWithOptions,
  eachYearOfInterval: () => eachYearOfInterval3,
  eachWeekendOfYearWithOptions: () => eachWeekendOfYearWithOptions,
  eachWeekendOfYear: () => eachWeekendOfYear3,
  eachWeekendOfMonthWithOptions: () => eachWeekendOfMonthWithOptions,
  eachWeekendOfMonth: () => eachWeekendOfMonth3,
  eachWeekendOfIntervalWithOptions: () => eachWeekendOfIntervalWithOptions,
  eachWeekendOfInterval: () => eachWeekendOfInterval3,
  eachWeekOfIntervalWithOptions: () => eachWeekOfIntervalWithOptions,
  eachWeekOfInterval: () => eachWeekOfInterval3,
  eachQuarterOfIntervalWithOptions: () => eachQuarterOfIntervalWithOptions,
  eachQuarterOfInterval: () => eachQuarterOfInterval3,
  eachMonthOfIntervalWithOptions: () => eachMonthOfIntervalWithOptions,
  eachMonthOfInterval: () => eachMonthOfInterval3,
  eachMinuteOfIntervalWithOptions: () => eachMinuteOfIntervalWithOptions,
  eachMinuteOfInterval: () => eachMinuteOfInterval3,
  eachHourOfIntervalWithOptions: () => eachHourOfIntervalWithOptions,
  eachHourOfInterval: () => eachHourOfInterval3,
  eachDayOfIntervalWithOptions: () => eachDayOfIntervalWithOptions,
  eachDayOfInterval: () => eachDayOfInterval3,
  differenceInYearsWithOptions: () => differenceInYearsWithOptions,
  differenceInYears: () => differenceInYears3,
  differenceInWeeksWithOptions: () => differenceInWeeksWithOptions,
  differenceInWeeks: () => differenceInWeeks3,
  differenceInSecondsWithOptions: () => differenceInSecondsWithOptions,
  differenceInSeconds: () => differenceInSeconds3,
  differenceInQuartersWithOptions: () => differenceInQuartersWithOptions,
  differenceInQuarters: () => differenceInQuarters3,
  differenceInMonthsWithOptions: () => differenceInMonthsWithOptions,
  differenceInMonths: () => differenceInMonths3,
  differenceInMinutesWithOptions: () => differenceInMinutesWithOptions,
  differenceInMinutes: () => differenceInMinutes3,
  differenceInMilliseconds: () => differenceInMilliseconds3,
  differenceInISOWeekYearsWithOptions: () => differenceInISOWeekYearsWithOptions,
  differenceInISOWeekYears: () => differenceInISOWeekYears3,
  differenceInHoursWithOptions: () => differenceInHoursWithOptions,
  differenceInHours: () => differenceInHours3,
  differenceInDaysWithOptions: () => differenceInDaysWithOptions,
  differenceInDays: () => differenceInDays3,
  differenceInCalendarYearsWithOptions: () => differenceInCalendarYearsWithOptions,
  differenceInCalendarYears: () => differenceInCalendarYears3,
  differenceInCalendarWeeksWithOptions: () => differenceInCalendarWeeksWithOptions,
  differenceInCalendarWeeks: () => differenceInCalendarWeeks3,
  differenceInCalendarQuartersWithOptions: () => differenceInCalendarQuartersWithOptions,
  differenceInCalendarQuarters: () => differenceInCalendarQuarters3,
  differenceInCalendarMonthsWithOptions: () => differenceInCalendarMonthsWithOptions,
  differenceInCalendarMonths: () => differenceInCalendarMonths3,
  differenceInCalendarISOWeeksWithOptions: () => differenceInCalendarISOWeeksWithOptions,
  differenceInCalendarISOWeeks: () => differenceInCalendarISOWeeks3,
  differenceInCalendarISOWeekYearsWithOptions: () => differenceInCalendarISOWeekYearsWithOptions,
  differenceInCalendarISOWeekYears: () => differenceInCalendarISOWeekYears3,
  differenceInCalendarDaysWithOptions: () => differenceInCalendarDaysWithOptions,
  differenceInCalendarDays: () => differenceInCalendarDays5,
  differenceInBusinessDaysWithOptions: () => differenceInBusinessDaysWithOptions,
  differenceInBusinessDays: () => differenceInBusinessDays3,
  daysToWeeks: () => daysToWeeks3,
  constructFrom: () => constructFrom16,
  compareDesc: () => compareDesc3,
  compareAsc: () => compareAsc3,
  closestToWithOptions: () => closestToWithOptions,
  closestTo: () => closestTo3,
  closestIndexTo: () => closestIndexTo3,
  clampWithOptions: () => clampWithOptions,
  clamp: () => clamp3,
  areIntervalsOverlappingWithOptions: () => areIntervalsOverlappingWithOptions,
  areIntervalsOverlapping: () => areIntervalsOverlapping3,
  addYearsWithOptions: () => addYearsWithOptions,
  addYears: () => addYears3,
  addWithOptions: () => addWithOptions,
  addWeeksWithOptions: () => addWeeksWithOptions,
  addWeeks: () => addWeeks3,
  addSecondsWithOptions: () => addSecondsWithOptions,
  addSeconds: () => addSeconds3,
  addQuartersWithOptions: () => addQuartersWithOptions,
  addQuarters: () => addQuarters3,
  addMonthsWithOptions: () => addMonthsWithOptions,
  addMonths: () => addMonths4,
  addMinutesWithOptions: () => addMinutesWithOptions,
  addMinutes: () => addMinutes3,
  addMillisecondsWithOptions: () => addMillisecondsWithOptions,
  addMilliseconds: () => addMilliseconds4,
  addISOWeekYearsWithOptions: () => addISOWeekYearsWithOptions,
  addISOWeekYears: () => addISOWeekYears3,
  addHoursWithOptions: () => addHoursWithOptions,
  addHours: () => addHours3,
  addDaysWithOptions: () => addDaysWithOptions,
  addDays: () => addDays4,
  addBusinessDaysWithOptions: () => addBusinessDaysWithOptions,
  addBusinessDays: () => addBusinessDays3,
  add: () => add3
});

// lib/constants.js
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
var minTime = -maxTime;
var millisecondsInWeek = 604800000;
var millisecondsInDay = 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minutesInYear = 525600;
var minutesInMonth = 43200;
var minutesInDay = 1440;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;
var constructFromSymbol = Symbol.for("constructDateFrom");

// lib/constructFrom.js
function constructFrom(date, value) {
  if (typeof date === "function")
    return date(value);
  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);
  if (date instanceof Date)
    return new date.constructor(value);
  return new Date(value);
}

// lib/toDate.js
function toDate(argument, context) {
  return constructFrom(context || argument, argument);
}

// lib/addDays.js
function addDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount))
    return constructFrom(options?.in || date, NaN);
  if (!amount)
    return _date;
  _date.setDate(_date.getDate() + amount);
  return _date;
}

// lib/addMonths.js
function addMonths(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount))
    return constructFrom(options?.in || date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(options?.in || date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return _date;
  }
}

// lib/add.js
function add(date, duration, options) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const _date = toDate(date, options?.in);
  const dateWithMonths = months || years ? addMonths(_date, months + years * 12) : _date;
  const dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  return constructFrom(options?.in || date, +dateWithDays + msToAdd);
}

// lib/fp/_lib/convertToFP.js
function convertToFP(fn, arity, curriedArgs = []) {
  return curriedArgs.length >= arity ? fn(...curriedArgs.slice(0, arity).reverse()) : (...args) => convertToFP(fn, arity, curriedArgs.concat(args));
}

// lib/fp/add.js
var add3 = convertToFP(add, 2);
// lib/isSaturday.js
function isSaturday(date, options) {
  return toDate(date, options?.in).getDay() === 6;
}

// lib/isSunday.js
function isSunday(date, options) {
  return toDate(date, options?.in).getDay() === 0;
}

// lib/isWeekend.js
function isWeekend(date, options) {
  const day = toDate(date, options?.in).getDay();
  return day === 0 || day === 6;
}

// lib/addBusinessDays.js
function addBusinessDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  const startedOnWeekend = isWeekend(_date, options);
  if (isNaN(amount))
    return constructFrom(options?.in, NaN);
  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);
  _date.setDate(_date.getDate() + fullWeeks * 7);
  let restDays = Math.abs(amount % 5);
  while (restDays > 0) {
    _date.setDate(_date.getDate() + sign);
    if (!isWeekend(_date, options))
      restDays -= 1;
  }
  if (startedOnWeekend && isWeekend(_date, options) && amount !== 0) {
    if (isSaturday(_date, options))
      _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
    if (isSunday(_date, options))
      _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
  }
  _date.setHours(hours);
  return _date;
}

// lib/fp/addBusinessDays.js
var addBusinessDays3 = convertToFP(addBusinessDays, 2);
// lib/fp/addBusinessDaysWithOptions.js
var addBusinessDaysWithOptions = convertToFP(addBusinessDays, 3);
// lib/fp/addDays.js
var addDays4 = convertToFP(addDays, 2);
// lib/fp/addDaysWithOptions.js
var addDaysWithOptions = convertToFP(addDays, 3);
// lib/addMilliseconds.js
function addMilliseconds(date, amount, options) {
  return constructFrom(options?.in || date, +toDate(date) + amount);
}

// lib/addHours.js
function addHours(date, amount, options) {
  return addMilliseconds(date, amount * millisecondsInHour, options);
}

// lib/fp/addHours.js
var addHours3 = convertToFP(addHours, 2);
// lib/fp/addHoursWithOptions.js
var addHoursWithOptions = convertToFP(addHours, 3);
// lib/_lib/defaultOptions.js
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
var defaultOptions = {};

// lib/startOfWeek.js
function startOfWeek(date, options) {
  const defaultOptions3 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions3.weekStartsOn ?? defaultOptions3.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// lib/startOfISOWeek.js
function startOfISOWeek(date, options) {
  return startOfWeek(date, { ...options, weekStartsOn: 1 });
}

// lib/getISOWeekYear.js
function getISOWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// lib/_lib/getTimezoneOffsetInMilliseconds.js
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

// lib/_lib/normalizeDates.js
function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(null, context || dates.find((date) => typeof date === "object"));
  return dates.map(normalize);
}

// lib/startOfDay.js
function startOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// lib/differenceInCalendarDays.js
function differenceInCalendarDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const laterStartOfDay = startOfDay(laterDate_);
  const earlierStartOfDay = startOfDay(earlierDate_);
  const laterTimestamp = +laterStartOfDay - getTimezoneOffsetInMilliseconds(laterStartOfDay);
  const earlierTimestamp = +earlierStartOfDay - getTimezoneOffsetInMilliseconds(earlierStartOfDay);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay);
}

// lib/startOfISOWeekYear.js
function startOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// lib/setISOWeekYear.js
function setISOWeekYear(date, weekYear, options) {
  let _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfISOWeekYear(_date, options));
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(weekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  _date = startOfISOWeekYear(fourthOfJanuary);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

// lib/addISOWeekYears.js
function addISOWeekYears(date, amount, options) {
  return setISOWeekYear(date, getISOWeekYear(date, options) + amount, options);
}

// lib/fp/addISOWeekYears.js
var addISOWeekYears3 = convertToFP(addISOWeekYears, 2);
// lib/fp/addISOWeekYearsWithOptions.js
var addISOWeekYearsWithOptions = convertToFP(addISOWeekYears, 3);
// lib/fp/addMilliseconds.js
var addMilliseconds4 = convertToFP(addMilliseconds, 2);
// lib/fp/addMillisecondsWithOptions.js
var addMillisecondsWithOptions = convertToFP(addMilliseconds, 3);
// lib/addMinutes.js
function addMinutes(date, amount, options) {
  const _date = toDate(date, options?.in);
  _date.setTime(_date.getTime() + amount * millisecondsInMinute);
  return _date;
}

// lib/fp/addMinutes.js
var addMinutes3 = convertToFP(addMinutes, 2);
// lib/fp/addMinutesWithOptions.js
var addMinutesWithOptions = convertToFP(addMinutes, 3);
// lib/fp/addMonths.js
var addMonths4 = convertToFP(addMonths, 2);
// lib/fp/addMonthsWithOptions.js
var addMonthsWithOptions = convertToFP(addMonths, 3);
// lib/addQuarters.js
function addQuarters(date, amount, options) {
  return addMonths(date, amount * 3, options);
}

// lib/fp/addQuarters.js
var addQuarters3 = convertToFP(addQuarters, 2);
// lib/fp/addQuartersWithOptions.js
var addQuartersWithOptions = convertToFP(addQuarters, 3);
// lib/addSeconds.js
function addSeconds(date, amount, options) {
  return addMilliseconds(date, amount * 1000, options);
}

// lib/fp/addSeconds.js
var addSeconds3 = convertToFP(addSeconds, 2);
// lib/fp/addSecondsWithOptions.js
var addSecondsWithOptions = convertToFP(addSeconds, 3);
// lib/addWeeks.js
function addWeeks(date, amount, options) {
  return addDays(date, amount * 7, options);
}

// lib/fp/addWeeks.js
var addWeeks3 = convertToFP(addWeeks, 2);
// lib/fp/addWeeksWithOptions.js
var addWeeksWithOptions = convertToFP(addWeeks, 3);
// lib/fp/addWithOptions.js
var addWithOptions = convertToFP(add, 3);
// lib/addYears.js
function addYears(date, amount, options) {
  return addMonths(date, amount * 12, options);
}

// lib/fp/addYears.js
var addYears3 = convertToFP(addYears, 2);
// lib/fp/addYearsWithOptions.js
var addYearsWithOptions = convertToFP(addYears, 3);
// lib/areIntervalsOverlapping.js
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  const [leftStartTime, leftEndTime] = [
    +toDate(intervalLeft.start, options?.in),
    +toDate(intervalLeft.end, options?.in)
  ].sort((a, b) => a - b);
  const [rightStartTime, rightEndTime] = [
    +toDate(intervalRight.start, options?.in),
    +toDate(intervalRight.end, options?.in)
  ].sort((a, b) => a - b);
  if (options?.inclusive)
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

// lib/fp/areIntervalsOverlapping.js
var areIntervalsOverlapping3 = convertToFP(areIntervalsOverlapping, 2);
// lib/fp/areIntervalsOverlappingWithOptions.js
var areIntervalsOverlappingWithOptions = convertToFP(areIntervalsOverlapping, 3);
// lib/max.js
function max(dates, options) {
  let result;
  let context = options?.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result < date_ || isNaN(+date_))
      result = date_;
  });
  return constructFrom(context, result || NaN);
}

// lib/min.js
function min(dates, options) {
  let result;
  let context = options?.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result > date_ || isNaN(+date_))
      result = date_;
  });
  return constructFrom(context, result || NaN);
}

// lib/clamp.js
function clamp(date, interval, options) {
  const [date_, start, end] = normalizeDates(options?.in, date, interval.start, interval.end);
  return min([max([date_, start], options), end], options);
}

// lib/fp/clamp.js
var clamp3 = convertToFP(clamp, 2);
// lib/fp/clampWithOptions.js
var clampWithOptions = convertToFP(clamp, 3);
// lib/closestIndexTo.js
function closestIndexTo(dateToCompare, dates) {
  const timeToCompare = +toDate(dateToCompare);
  if (isNaN(timeToCompare))
    return NaN;
  let result;
  let minDistance;
  dates.forEach((date, index) => {
    const date_ = toDate(date);
    if (isNaN(+date_)) {
      result = NaN;
      minDistance = NaN;
      return;
    }
    const distance = Math.abs(timeToCompare - +date_);
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}

// lib/fp/closestIndexTo.js
var closestIndexTo3 = convertToFP(closestIndexTo, 2);
// lib/closestTo.js
function closestTo(dateToCompare, dates, options) {
  const [dateToCompare_, ...dates_] = normalizeDates(options?.in, dateToCompare, ...dates);
  const index = closestIndexTo(dateToCompare_, dates_);
  if (typeof index === "number" && isNaN(index))
    return constructFrom(dateToCompare_, NaN);
  if (index !== undefined)
    return dates_[index];
}

// lib/fp/closestTo.js
var closestTo3 = convertToFP(closestTo, 2);
// lib/fp/closestToWithOptions.js
var closestToWithOptions = convertToFP(closestTo, 3);
// lib/compareAsc.js
function compareAsc(dateLeft, dateRight) {
  const diff = +toDate(dateLeft) - +toDate(dateRight);
  if (diff < 0)
    return -1;
  else if (diff > 0)
    return 1;
  return diff;
}

// lib/fp/compareAsc.js
var compareAsc3 = convertToFP(compareAsc, 2);
// lib/compareDesc.js
function compareDesc(dateLeft, dateRight) {
  const diff = +toDate(dateLeft) - +toDate(dateRight);
  if (diff > 0)
    return -1;
  else if (diff < 0)
    return 1;
  return diff;
}

// lib/fp/compareDesc.js
var compareDesc3 = convertToFP(compareDesc, 2);
// lib/fp/constructFrom.js
var constructFrom16 = convertToFP(constructFrom, 2);
// lib/daysToWeeks.js
function daysToWeeks(days) {
  const result = Math.trunc(days / daysInWeek);
  return result === 0 ? 0 : result;
}

// lib/fp/daysToWeeks.js
var daysToWeeks3 = convertToFP(daysToWeeks, 1);
// lib/isSameDay.js
function isSameDay(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfDay(dateLeft_) === +startOfDay(dateRight_);
}

// lib/isDate.js
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// lib/isValid.js
function isValid(date) {
  return !(!isDate(date) && typeof date !== "number" || isNaN(+toDate(date)));
}

// lib/differenceInBusinessDays.js
function differenceInBusinessDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  if (!isValid(laterDate_) || !isValid(earlierDate_))
    return NaN;
  const diff = differenceInCalendarDays(laterDate_, earlierDate_);
  const sign = diff < 0 ? -1 : 1;
  const weeks = Math.trunc(diff / 7);
  let result = weeks * 5;
  let movingDate = addDays(earlierDate_, weeks * 7);
  while (!isSameDay(laterDate_, movingDate)) {
    result += isWeekend(movingDate, options) ? 0 : sign;
    movingDate = addDays(movingDate, sign);
  }
  return result === 0 ? 0 : result;
}

// lib/fp/differenceInBusinessDays.js
var differenceInBusinessDays3 = convertToFP(differenceInBusinessDays, 2);
// lib/fp/differenceInBusinessDaysWithOptions.js
var differenceInBusinessDaysWithOptions = convertToFP(differenceInBusinessDays, 3);
// lib/fp/differenceInCalendarDays.js
var differenceInCalendarDays5 = convertToFP(differenceInCalendarDays, 2);
// lib/fp/differenceInCalendarDaysWithOptions.js
var differenceInCalendarDaysWithOptions = convertToFP(differenceInCalendarDays, 3);
// lib/differenceInCalendarISOWeekYears.js
function differenceInCalendarISOWeekYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return getISOWeekYear(laterDate_, options) - getISOWeekYear(earlierDate_, options);
}

// lib/fp/differenceInCalendarISOWeekYears.js
var differenceInCalendarISOWeekYears3 = convertToFP(differenceInCalendarISOWeekYears, 2);
// lib/fp/differenceInCalendarISOWeekYearsWithOptions.js
var differenceInCalendarISOWeekYearsWithOptions = convertToFP(differenceInCalendarISOWeekYears, 3);
// lib/differenceInCalendarISOWeeks.js
function differenceInCalendarISOWeeks(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const startOfISOWeekLeft = startOfISOWeek(laterDate_);
  const startOfISOWeekRight = startOfISOWeek(earlierDate_);
  const timestampLeft = +startOfISOWeekLeft - getTimezoneOffsetInMilliseconds(startOfISOWeekLeft);
  const timestampRight = +startOfISOWeekRight - getTimezoneOffsetInMilliseconds(startOfISOWeekRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}

// lib/fp/differenceInCalendarISOWeeks.js
var differenceInCalendarISOWeeks3 = convertToFP(differenceInCalendarISOWeeks, 2);
// lib/fp/differenceInCalendarISOWeeksWithOptions.js
var differenceInCalendarISOWeeksWithOptions = convertToFP(differenceInCalendarISOWeeks, 3);
// lib/differenceInCalendarMonths.js
function differenceInCalendarMonths(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
  return yearsDiff * 12 + monthsDiff;
}

// lib/fp/differenceInCalendarMonths.js
var differenceInCalendarMonths3 = convertToFP(differenceInCalendarMonths, 2);
// lib/fp/differenceInCalendarMonthsWithOptions.js
var differenceInCalendarMonthsWithOptions = convertToFP(differenceInCalendarMonths, 3);
// lib/getQuarter.js
function getQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}

// lib/differenceInCalendarQuarters.js
function differenceInCalendarQuarters(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const quartersDiff = getQuarter(laterDate_) - getQuarter(earlierDate_);
  return yearsDiff * 4 + quartersDiff;
}

// lib/fp/differenceInCalendarQuarters.js
var differenceInCalendarQuarters3 = convertToFP(differenceInCalendarQuarters, 2);
// lib/fp/differenceInCalendarQuartersWithOptions.js
var differenceInCalendarQuartersWithOptions = convertToFP(differenceInCalendarQuarters, 3);
// lib/differenceInCalendarWeeks.js
function differenceInCalendarWeeks(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const laterStartOfWeek = startOfWeek(laterDate_, options);
  const earlierStartOfWeek = startOfWeek(earlierDate_, options);
  const laterTimestamp = +laterStartOfWeek - getTimezoneOffsetInMilliseconds(laterStartOfWeek);
  const earlierTimestamp = +earlierStartOfWeek - getTimezoneOffsetInMilliseconds(earlierStartOfWeek);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInWeek);
}

// lib/fp/differenceInCalendarWeeks.js
var differenceInCalendarWeeks3 = convertToFP(differenceInCalendarWeeks, 2);
// lib/fp/differenceInCalendarWeeksWithOptions.js
var differenceInCalendarWeeksWithOptions = convertToFP(differenceInCalendarWeeks, 3);
// lib/differenceInCalendarYears.js
function differenceInCalendarYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() - earlierDate_.getFullYear();
}

// lib/fp/differenceInCalendarYears.js
var differenceInCalendarYears3 = convertToFP(differenceInCalendarYears, 2);
// lib/fp/differenceInCalendarYearsWithOptions.js
var differenceInCalendarYearsWithOptions = convertToFP(differenceInCalendarYears, 3);
// lib/differenceInDays.js
function differenceInDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareLocalAsc(laterDate_, earlierDate_);
  const difference = Math.abs(differenceInCalendarDays(laterDate_, earlierDate_));
  laterDate_.setDate(laterDate_.getDate() - sign * difference);
  const isLastDayNotFull = Number(compareLocalAsc(laterDate_, earlierDate_) === -sign);
  const result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function compareLocalAsc(laterDate, earlierDate) {
  const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
  if (diff < 0)
    return -1;
  if (diff > 0)
    return 1;
  return diff;
}

// lib/fp/differenceInDays.js
var differenceInDays3 = convertToFP(differenceInDays, 2);
// lib/fp/differenceInDaysWithOptions.js
var differenceInDaysWithOptions = convertToFP(differenceInDays, 3);
// lib/_lib/getRoundingMethod.js
function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    return result === 0 ? 0 : result;
  };
}

// lib/differenceInHours.js
function differenceInHours(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const diff = (+laterDate_ - +earlierDate_) / millisecondsInHour;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// lib/fp/differenceInHours.js
var differenceInHours3 = convertToFP(differenceInHours, 2);
// lib/fp/differenceInHoursWithOptions.js
var differenceInHoursWithOptions = convertToFP(differenceInHours, 3);
// lib/subISOWeekYears.js
function subISOWeekYears(date, amount, options) {
  return addISOWeekYears(date, -amount, options);
}

// lib/differenceInISOWeekYears.js
function differenceInISOWeekYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareAsc(laterDate_, earlierDate_);
  const diff = Math.abs(differenceInCalendarISOWeekYears(laterDate_, earlierDate_, options));
  const adjustedDate = subISOWeekYears(laterDate_, sign * diff, options);
  const isLastISOWeekYearNotFull = Number(compareAsc(adjustedDate, earlierDate_) === -sign);
  const result = sign * (diff - isLastISOWeekYearNotFull);
  return result === 0 ? 0 : result;
}

// lib/fp/differenceInISOWeekYears.js
var differenceInISOWeekYears3 = convertToFP(differenceInISOWeekYears, 2);
// lib/fp/differenceInISOWeekYearsWithOptions.js
var differenceInISOWeekYearsWithOptions = convertToFP(differenceInISOWeekYears, 3);
// lib/differenceInMilliseconds.js
function differenceInMilliseconds(laterDate, earlierDate) {
  return +toDate(laterDate) - +toDate(earlierDate);
}

// lib/fp/differenceInMilliseconds.js
var differenceInMilliseconds3 = convertToFP(differenceInMilliseconds, 2);
// lib/differenceInMinutes.js
function differenceInMinutes(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// lib/fp/differenceInMinutes.js
var differenceInMinutes3 = convertToFP(differenceInMinutes, 2);
// lib/fp/differenceInMinutesWithOptions.js
var differenceInMinutesWithOptions = convertToFP(differenceInMinutes, 3);
// lib/endOfDay.js
function endOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/endOfMonth.js
function endOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/isLastDayOfMonth.js
function isLastDayOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  return +endOfDay(_date, options) === +endOfMonth(_date, options);
}

// lib/differenceInMonths.js
function differenceInMonths(laterDate, earlierDate, options) {
  const [laterDate_, workingLaterDate, earlierDate_] = normalizeDates(options?.in, laterDate, laterDate, earlierDate);
  const sign = compareAsc(workingLaterDate, earlierDate_);
  const difference = Math.abs(differenceInCalendarMonths(workingLaterDate, earlierDate_));
  if (difference < 1)
    return 0;
  if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27)
    workingLaterDate.setDate(30);
  workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
  let isLastMonthNotFull = compareAsc(workingLaterDate, earlierDate_) === -sign;
  if (isLastDayOfMonth(laterDate_) && difference === 1 && compareAsc(laterDate_, earlierDate_) === 1) {
    isLastMonthNotFull = false;
  }
  const result = sign * (difference - +isLastMonthNotFull);
  return result === 0 ? 0 : result;
}

// lib/fp/differenceInMonths.js
var differenceInMonths3 = convertToFP(differenceInMonths, 2);
// lib/fp/differenceInMonthsWithOptions.js
var differenceInMonthsWithOptions = convertToFP(differenceInMonths, 3);
// lib/differenceInQuarters.js
function differenceInQuarters(laterDate, earlierDate, options) {
  const diff = differenceInMonths(laterDate, earlierDate, options) / 3;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// lib/fp/differenceInQuarters.js
var differenceInQuarters3 = convertToFP(differenceInQuarters, 2);
// lib/fp/differenceInQuartersWithOptions.js
var differenceInQuartersWithOptions = convertToFP(differenceInQuarters, 3);
// lib/differenceInSeconds.js
function differenceInSeconds(laterDate, earlierDate, options) {
  const diff = differenceInMilliseconds(laterDate, earlierDate) / 1000;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// lib/fp/differenceInSeconds.js
var differenceInSeconds3 = convertToFP(differenceInSeconds, 2);
// lib/fp/differenceInSecondsWithOptions.js
var differenceInSecondsWithOptions = convertToFP(differenceInSeconds, 3);
// lib/differenceInWeeks.js
function differenceInWeeks(laterDate, earlierDate, options) {
  const diff = differenceInDays(laterDate, earlierDate, options) / 7;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// lib/fp/differenceInWeeks.js
var differenceInWeeks3 = convertToFP(differenceInWeeks, 2);
// lib/fp/differenceInWeeksWithOptions.js
var differenceInWeeksWithOptions = convertToFP(differenceInWeeks, 3);
// lib/differenceInYears.js
function differenceInYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareAsc(laterDate_, earlierDate_);
  const diff = Math.abs(differenceInCalendarYears(laterDate_, earlierDate_));
  laterDate_.setFullYear(1584);
  earlierDate_.setFullYear(1584);
  const partial = compareAsc(laterDate_, earlierDate_) === -sign;
  const result = sign * (diff - +partial);
  return result === 0 ? 0 : result;
}

// lib/fp/differenceInYears.js
var differenceInYears3 = convertToFP(differenceInYears, 2);
// lib/fp/differenceInYearsWithOptions.js
var differenceInYearsWithOptions = convertToFP(differenceInYears, 3);
// lib/_lib/normalizeInterval.js
function normalizeInterval(context, interval) {
  const [start, end] = normalizeDates(context, interval.start, interval.end);
  return { start, end };
}

// lib/eachDayOfInterval.js
function eachDayOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setDate(date.getDate() + step);
    date.setHours(0, 0, 0, 0);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachDayOfInterval.js
var eachDayOfInterval3 = convertToFP(eachDayOfInterval, 1);
// lib/fp/eachDayOfIntervalWithOptions.js
var eachDayOfIntervalWithOptions = convertToFP(eachDayOfInterval, 2);
// lib/eachHourOfInterval.js
function eachHourOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setMinutes(0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setHours(date.getHours() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachHourOfInterval.js
var eachHourOfInterval3 = convertToFP(eachHourOfInterval, 1);
// lib/fp/eachHourOfIntervalWithOptions.js
var eachHourOfIntervalWithOptions = convertToFP(eachHourOfInterval, 2);
// lib/eachMinuteOfInterval.js
function eachMinuteOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  start.setSeconds(0, 0);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  let date = reversed ? end : start;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date = addMinutes(date, step);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachMinuteOfInterval.js
var eachMinuteOfInterval3 = convertToFP(eachMinuteOfInterval, 1);
// lib/fp/eachMinuteOfIntervalWithOptions.js
var eachMinuteOfIntervalWithOptions = convertToFP(eachMinuteOfInterval, 2);
// lib/eachMonthOfInterval.js
function eachMonthOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setDate(1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setMonth(date.getMonth() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachMonthOfInterval.js
var eachMonthOfInterval3 = convertToFP(eachMonthOfInterval, 1);
// lib/fp/eachMonthOfIntervalWithOptions.js
var eachMonthOfIntervalWithOptions = convertToFP(eachMonthOfInterval, 2);
// lib/startOfQuarter.js
function startOfQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3;
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// lib/eachQuarterOfInterval.js
function eachQuarterOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +startOfQuarter(start) : +startOfQuarter(end);
  let date = reversed ? startOfQuarter(end) : startOfQuarter(start);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date = addQuarters(date, step);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachQuarterOfInterval.js
var eachQuarterOfInterval3 = convertToFP(eachQuarterOfInterval, 1);
// lib/fp/eachQuarterOfIntervalWithOptions.js
var eachQuarterOfIntervalWithOptions = convertToFP(eachQuarterOfInterval, 2);
// lib/eachWeekOfInterval.js
function eachWeekOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const startDateWeek = reversed ? startOfWeek(end, options) : startOfWeek(start, options);
  const endDateWeek = reversed ? startOfWeek(start, options) : startOfWeek(end, options);
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push(constructFrom(start, currentDate));
    currentDate = addWeeks(currentDate, step);
    currentDate.setHours(15);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachWeekOfInterval.js
var eachWeekOfInterval3 = convertToFP(eachWeekOfInterval, 1);
// lib/fp/eachWeekOfIntervalWithOptions.js
var eachWeekOfIntervalWithOptions = convertToFP(eachWeekOfInterval, 2);
// lib/eachWeekendOfInterval.js
function eachWeekendOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  const dateInterval = eachDayOfInterval({ start, end }, options);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if (isWeekend(date))
      weekends.push(constructFrom(start, date));
  }
  return weekends;
}

// lib/fp/eachWeekendOfInterval.js
var eachWeekendOfInterval3 = convertToFP(eachWeekendOfInterval, 1);
// lib/fp/eachWeekendOfIntervalWithOptions.js
var eachWeekendOfIntervalWithOptions = convertToFP(eachWeekendOfInterval, 2);
// lib/startOfMonth.js
function startOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// lib/eachWeekendOfMonth.js
function eachWeekendOfMonth(date, options) {
  const start = startOfMonth(date, options);
  const end = endOfMonth(date, options);
  return eachWeekendOfInterval({ start, end }, options);
}

// lib/fp/eachWeekendOfMonth.js
var eachWeekendOfMonth3 = convertToFP(eachWeekendOfMonth, 1);
// lib/fp/eachWeekendOfMonthWithOptions.js
var eachWeekendOfMonthWithOptions = convertToFP(eachWeekendOfMonth, 2);
// lib/endOfYear.js
function endOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/startOfYear.js
function startOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// lib/eachWeekendOfYear.js
function eachWeekendOfYear(date, options) {
  const start = startOfYear(date, options);
  const end = endOfYear(date, options);
  return eachWeekendOfInterval({ start, end }, options);
}

// lib/fp/eachWeekendOfYear.js
var eachWeekendOfYear3 = convertToFP(eachWeekendOfYear, 1);
// lib/fp/eachWeekendOfYearWithOptions.js
var eachWeekendOfYearWithOptions = convertToFP(eachWeekendOfYear, 2);
// lib/eachYearOfInterval.js
function eachYearOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setMonth(0, 1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setFullYear(date.getFullYear() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// lib/fp/eachYearOfInterval.js
var eachYearOfInterval3 = convertToFP(eachYearOfInterval, 1);
// lib/fp/eachYearOfIntervalWithOptions.js
var eachYearOfIntervalWithOptions = convertToFP(eachYearOfInterval, 2);
// lib/fp/endOfDay.js
var endOfDay4 = convertToFP(endOfDay, 1);
// lib/fp/endOfDayWithOptions.js
var endOfDayWithOptions = convertToFP(endOfDay, 2);
// lib/endOfDecade.js
function endOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 11, 31);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/fp/endOfDecade.js
var endOfDecade3 = convertToFP(endOfDecade, 1);
// lib/fp/endOfDecadeWithOptions.js
var endOfDecadeWithOptions = convertToFP(endOfDecade, 2);
// lib/endOfHour.js
function endOfHour(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMinutes(59, 59, 999);
  return _date;
}

// lib/fp/endOfHour.js
var endOfHour3 = convertToFP(endOfHour, 1);
// lib/fp/endOfHourWithOptions.js
var endOfHourWithOptions = convertToFP(endOfHour, 2);
// lib/endOfWeek.js
function endOfWeek(date, options) {
  const defaultOptions4 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions4.weekStartsOn ?? defaultOptions4.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/endOfISOWeek.js
function endOfISOWeek(date, options) {
  return endOfWeek(date, { ...options, weekStartsOn: 1 });
}

// lib/fp/endOfISOWeek.js
var endOfISOWeek3 = convertToFP(endOfISOWeek, 1);
// lib/fp/endOfISOWeekWithOptions.js
var endOfISOWeekWithOptions = convertToFP(endOfISOWeek, 2);
// lib/endOfISOWeekYear.js
function endOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuaryOfNextYear = constructFrom(options?.in || date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const _date = startOfISOWeek(fourthOfJanuaryOfNextYear, options);
  _date.setMilliseconds(_date.getMilliseconds() - 1);
  return _date;
}

// lib/fp/endOfISOWeekYear.js
var endOfISOWeekYear3 = convertToFP(endOfISOWeekYear, 1);
// lib/fp/endOfISOWeekYearWithOptions.js
var endOfISOWeekYearWithOptions = convertToFP(endOfISOWeekYear, 2);
// lib/endOfMinute.js
function endOfMinute(date, options) {
  const _date = toDate(date, options?.in);
  _date.setSeconds(59, 999);
  return _date;
}

// lib/fp/endOfMinute.js
var endOfMinute3 = convertToFP(endOfMinute, 1);
// lib/fp/endOfMinuteWithOptions.js
var endOfMinuteWithOptions = convertToFP(endOfMinute, 2);
// lib/fp/endOfMonth.js
var endOfMonth5 = convertToFP(endOfMonth, 1);
// lib/fp/endOfMonthWithOptions.js
var endOfMonthWithOptions = convertToFP(endOfMonth, 2);
// lib/endOfQuarter.js
function endOfQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3 + 3;
  _date.setMonth(month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// lib/fp/endOfQuarter.js
var endOfQuarter3 = convertToFP(endOfQuarter, 1);
// lib/fp/endOfQuarterWithOptions.js
var endOfQuarterWithOptions = convertToFP(endOfQuarter, 2);
// lib/endOfSecond.js
function endOfSecond(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMilliseconds(999);
  return _date;
}

// lib/fp/endOfSecond.js
var endOfSecond3 = convertToFP(endOfSecond, 1);
// lib/fp/endOfSecondWithOptions.js
var endOfSecondWithOptions = convertToFP(endOfSecond, 2);
// lib/fp/endOfWeek.js
var endOfWeek4 = convertToFP(endOfWeek, 1);
// lib/fp/endOfWeekWithOptions.js
var endOfWeekWithOptions = convertToFP(endOfWeek, 2);
// lib/fp/endOfYear.js
var endOfYear4 = convertToFP(endOfYear, 1);
// lib/fp/endOfYearWithOptions.js
var endOfYearWithOptions = convertToFP(endOfYear, 2);
// lib/locale/en-US/_lib/formatDistance.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};

// lib/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

// lib/locale/en-US/_lib/formatLong.js
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};

// lib/locale/en-US/_lib/formatRelative.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];

// lib/locale/_lib/buildLocalizeFn.js
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}

// lib/locale/en-US/_lib/localize.js
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};

// lib/locale/_lib/buildMatchFn.js
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : findKey(parsePatterns, (pattern) => pattern.test(matchedString));
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return;
}
function findIndex(array, predicate) {
  for (let key = 0;key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return;
}

// lib/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}

// lib/locale/en-US/_lib/match.js
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};

// lib/locale/en-US.js
var enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
// lib/getDayOfYear.js
function getDayOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// lib/getISOWeek.js
function getISOWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// lib/getWeekYear.js
function getWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const defaultOptions5 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions5.firstWeekContainsDate ?? defaultOptions5.locale?.options?.firstWeekContainsDate ?? 1;
  const firstWeekOfNextYear = constructFrom(options?.in || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(options?.in || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}

// lib/startOfWeekYear.js
function startOfWeekYear(date, options) {
  const defaultOptions6 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions6.firstWeekContainsDate ?? defaultOptions6.locale?.options?.firstWeekContainsDate ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// lib/getWeek.js
function getWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// lib/_lib/addLeadingZeros.js
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

// lib/_lib/format/lightFormatters.js
var lightFormatters = {
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

// lib/_lib/format/formatters.js
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function(date, token, localize3) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize3.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize3.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize3.era(era, { width: "wide" });
    }
  },
  y: function(date, token, localize3) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize3.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  Y: function(date, token, localize3, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize3.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function(date, token, localize3) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize3.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize3.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize3.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize3.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date, token, localize3) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize3.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize3.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize3.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize3.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date, token, localize3) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize3.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize3.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize3.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize3.month(month, { width: "wide", context: "formatting" });
    }
  },
  L: function(date, token, localize3) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize3.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize3.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize3.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize3.month(month, { width: "wide", context: "standalone" });
    }
  },
  w: function(date, token, localize3, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize3.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function(date, token, localize3) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize3.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function(date, token, localize3) {
    if (token === "do") {
      return localize3.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  D: function(date, token, localize3) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize3.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function(date, token, localize3) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date, token, localize3, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize3.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date, token, localize3, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize3.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date, token, localize3) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize3.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize3.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize3.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize3.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize3.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date, token, localize3) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date, token, localize3) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date, token, localize3) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize3.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date, token, localize3) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  H: function(date, token, localize3) {
    if (token === "Ho") {
      return localize3.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  K: function(date, token, localize3) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function(date, token, localize3) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize3.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function(date, token, localize3) {
    if (token === "mo") {
      return localize3.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  s: function(date, token, localize3) {
    if (token === "so") {
      return localize3.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(+date / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function(date, token, _localize) {
    return addLeadingZeros(+date, token.length);
  }
};

// lib/_lib/format/longFormatters.js
var dateLongFormatter = (pattern, formatLong3) => {
  switch (pattern) {
    case "P":
      return formatLong3.date({ width: "short" });
    case "PP":
      return formatLong3.date({ width: "medium" });
    case "PPP":
      return formatLong3.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong3.date({ width: "full" });
  }
};
var timeLongFormatter = (pattern, formatLong3) => {
  switch (pattern) {
    case "p":
      return formatLong3.time({ width: "short" });
    case "pp":
      return formatLong3.time({ width: "medium" });
    case "ppp":
      return formatLong3.time({ width: "long" });
    case "pppp":
    default:
      return formatLong3.time({ width: "full" });
  }
};
var dateTimeLongFormatter = (pattern, formatLong3) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong3);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong3.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong3.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong3.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong3.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong3)).replace("{{time}}", timeLongFormatter(timePattern, formatLong3));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

// lib/_lib/protectedTokens.js
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
var dayOfYearTokenRE = /^D+$/;
var weekYearTokenRE = /^Y+$/;
var throwTokens = ["D", "DD", "YY", "YYYY"];

// lib/format.js
function format(date, formatStr, options) {
  const defaultOptions7 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions7.locale ?? enUS;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions7.firstWeekContainsDate ?? defaultOptions7.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions7.weekStartsOn ?? defaultOptions7.locale?.options?.weekStartsOn ?? 0;
  const originalDate = toDate(date, options?.in);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token) || !options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

// lib/fp/format.js
var format3 = convertToFP(format, 2);
// lib/formatDistance.js
function formatDistance3(laterDate, earlierDate, options) {
  const defaultOptions8 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions8.locale ?? enUS;
  const minutesInAlmostTwoDays = 2520;
  const comparison = compareAsc(laterDate, earlierDate);
  if (isNaN(comparison))
    throw new RangeError("Invalid time value");
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, ...comparison > 0 ? [earlierDate, laterDate] : [laterDate, earlierDate]);
  const seconds = differenceInSeconds(earlierDate_, laterDate_);
  const offsetInSeconds = (getTimezoneOffsetInMilliseconds(earlierDate_) - getTimezoneOffsetInMilliseconds(laterDate_)) / 1000;
  const minutes = Math.round((seconds - offsetInSeconds) / 60);
  let months;
  if (minutes < 2) {
    if (options?.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }
  } else if (minutes < 45) {
    return locale.formatDistance("xMinutes", minutes, localizeOptions);
  } else if (minutes < 90) {
    return locale.formatDistance("aboutXHours", 1, localizeOptions);
  } else if (minutes < minutesInDay) {
    const hours = Math.round(minutes / 60);
    return locale.formatDistance("aboutXHours", hours, localizeOptions);
  } else if (minutes < minutesInAlmostTwoDays) {
    return locale.formatDistance("xDays", 1, localizeOptions);
  } else if (minutes < minutesInMonth) {
    const days = Math.round(minutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (minutes < minutesInMonth * 2) {
    months = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("aboutXMonths", months, localizeOptions);
  }
  months = differenceInMonths(earlierDate_, laterDate_);
  if (months < 12) {
    const nearestMonth = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
  } else {
    const monthsSinceStartOfYear = months % 12;
    const years = Math.trunc(months / 12);
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance("aboutXYears", years, localizeOptions);
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance("overXYears", years, localizeOptions);
    } else {
      return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}

// lib/fp/formatDistance.js
var formatDistance5 = convertToFP(formatDistance3, 2);
// lib/formatDistanceStrict.js
function formatDistanceStrict(laterDate, earlierDate, options) {
  const defaultOptions9 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions9.locale ?? enUS;
  const comparison = compareAsc(laterDate, earlierDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, ...comparison > 0 ? [earlierDate, laterDate] : [laterDate, earlierDate]);
  const roundingMethod = getRoundingMethod(options?.roundingMethod ?? "round");
  const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
  const minutes = milliseconds / millisecondsInMinute;
  const timezoneOffset = getTimezoneOffsetInMilliseconds(earlierDate_) - getTimezoneOffsetInMilliseconds(laterDate_);
  const dstNormalizedMinutes = (milliseconds - timezoneOffset) / millisecondsInMinute;
  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (unit === "month") {
    const months = roundingMethod(dstNormalizedMinutes / minutesInMonth);
    return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
  } else {
    const years = roundingMethod(dstNormalizedMinutes / minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}

// lib/fp/formatDistanceStrict.js
var formatDistanceStrict3 = convertToFP(formatDistanceStrict, 2);
// lib/fp/formatDistanceStrictWithOptions.js
var formatDistanceStrictWithOptions = convertToFP(formatDistanceStrict, 3);
// lib/fp/formatDistanceWithOptions.js
var formatDistanceWithOptions = convertToFP(formatDistance3, 3);
// lib/formatDuration.js
function formatDuration(duration, options) {
  const defaultOptions10 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions10.locale ?? enUS;
  const format4 = options?.format ?? defaultFormat;
  const zero = options?.zero ?? false;
  const delimiter = options?.delimiter ?? " ";
  if (!locale.formatDistance) {
    return "";
  }
  const result = format4.reduce((acc, unit) => {
    const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
    const value = duration[unit];
    if (value !== undefined && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
var defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];

// lib/fp/formatDuration.js
var formatDuration3 = convertToFP(formatDuration, 1);
// lib/fp/formatDurationWithOptions.js
var formatDurationWithOptions = convertToFP(formatDuration, 2);
// lib/formatISO.js
function formatISO(date, options) {
  const date_ = toDate(date, options?.in);
  if (isNaN(+date_)) {
    throw new RangeError("Invalid time value");
  }
  const format4 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  let tzOffset = "";
  const dateDelimiter = format4 === "extended" ? "-" : "";
  const timeDelimiter = format4 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(date_.getDate(), 2);
    const month = addLeadingZeros(date_.getMonth() + 1, 2);
    const year = addLeadingZeros(date_.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const offset = date_.getTimezoneOffset();
    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
      const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      const sign = offset < 0 ? "+" : "-";
      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }
    const hour = addLeadingZeros(date_.getHours(), 2);
    const minute = addLeadingZeros(date_.getMinutes(), 2);
    const second = addLeadingZeros(date_.getSeconds(), 2);
    const separator = result === "" ? "" : "T";
    const time = [hour, minute, second].join(timeDelimiter);
    result = `${result}${separator}${time}${tzOffset}`;
  }
  return result;
}

// lib/fp/formatISO.js
var formatISO3 = convertToFP(formatISO, 1);
// lib/formatISO9075.js
function formatISO9075(date, options) {
  const date_ = toDate(date, options?.in);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const format4 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  const dateDelimiter = format4 === "extended" ? "-" : "";
  const timeDelimiter = format4 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(date_.getDate(), 2);
    const month = addLeadingZeros(date_.getMonth() + 1, 2);
    const year = addLeadingZeros(date_.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const hour = addLeadingZeros(date_.getHours(), 2);
    const minute = addLeadingZeros(date_.getMinutes(), 2);
    const second = addLeadingZeros(date_.getSeconds(), 2);
    const separator = result === "" ? "" : " ";
    result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
  }
  return result;
}

// lib/fp/formatISO9075.js
var formatISO90753 = convertToFP(formatISO9075, 1);
// lib/fp/formatISO9075WithOptions.js
var formatISO9075WithOptions = convertToFP(formatISO9075, 2);
// lib/formatISODuration.js
function formatISODuration(duration) {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

// lib/fp/formatISODuration.js
var formatISODuration3 = convertToFP(formatISODuration, 1);
// lib/fp/formatISOWithOptions.js
var formatISOWithOptions = convertToFP(formatISO, 2);
// lib/formatRFC3339.js
function formatRFC3339(date, options) {
  const date_ = toDate(date, options?.in);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const fractionDigits = options?.fractionDigits ?? 0;
  const day = addLeadingZeros(date_.getDate(), 2);
  const month = addLeadingZeros(date_.getMonth() + 1, 2);
  const year = date_.getFullYear();
  const hour = addLeadingZeros(date_.getHours(), 2);
  const minute = addLeadingZeros(date_.getMinutes(), 2);
  const second = addLeadingZeros(date_.getSeconds(), 2);
  let fractionalSecond = "";
  if (fractionDigits > 0) {
    const milliseconds = date_.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = "." + addLeadingZeros(fractionalSeconds, fractionDigits);
  }
  let offset = "";
  const tzOffset = date_.getTimezoneOffset();
  if (tzOffset !== 0) {
    const absoluteOffset = Math.abs(tzOffset);
    const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
    const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
    const sign = tzOffset < 0 ? "+" : "-";
    offset = `${sign}${hourOffset}:${minuteOffset}`;
  } else {
    offset = "Z";
  }
  return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

// lib/fp/formatRFC3339.js
var formatRFC33393 = convertToFP(formatRFC3339, 1);
// lib/fp/formatRFC3339WithOptions.js
var formatRFC3339WithOptions = convertToFP(formatRFC3339, 2);
// lib/formatRFC7231.js
function formatRFC7231(date) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const dayName = days[_date.getUTCDay()];
  const dayOfMonth = addLeadingZeros(_date.getUTCDate(), 2);
  const monthName = months[_date.getUTCMonth()];
  const year = _date.getUTCFullYear();
  const hour = addLeadingZeros(_date.getUTCHours(), 2);
  const minute = addLeadingZeros(_date.getUTCMinutes(), 2);
  const second = addLeadingZeros(_date.getUTCSeconds(), 2);
  return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

// lib/fp/formatRFC7231.js
var formatRFC72313 = convertToFP(formatRFC7231, 1);
// lib/formatRelative.js
function formatRelative3(date, baseDate, options) {
  const [date_, baseDate_] = normalizeDates(options?.in, date, baseDate);
  const defaultOptions11 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions11.locale ?? enUS;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions11.weekStartsOn ?? defaultOptions11.locale?.options?.weekStartsOn ?? 0;
  const diff = differenceInCalendarDays(date_, baseDate_);
  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }
  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }
  const formatStr = locale.formatRelative(token, date_, baseDate_, {
    locale,
    weekStartsOn
  });
  return format(date_, formatStr, { locale, weekStartsOn });
}

// lib/fp/formatRelative.js
var formatRelative5 = convertToFP(formatRelative3, 2);
// lib/fp/formatRelativeWithOptions.js
var formatRelativeWithOptions = convertToFP(formatRelative3, 3);
// lib/fp/formatWithOptions.js
var formatWithOptions = convertToFP(format, 3);
// lib/fromUnixTime.js
function fromUnixTime(unixTime, options) {
  return toDate(unixTime * 1000, options?.in);
}

// lib/fp/fromUnixTime.js
var fromUnixTime3 = convertToFP(fromUnixTime, 1);
// lib/fp/fromUnixTimeWithOptions.js
var fromUnixTimeWithOptions = convertToFP(fromUnixTime, 2);
// lib/getDate.js
function getDate(date, options) {
  return toDate(date, options?.in).getDate();
}

// lib/fp/getDate.js
var getDate3 = convertToFP(getDate, 1);
// lib/fp/getDateWithOptions.js
var getDateWithOptions = convertToFP(getDate, 2);
// lib/getDay.js
function getDay(date, options) {
  return toDate(date, options?.in).getDay();
}

// lib/fp/getDay.js
var getDay3 = convertToFP(getDay, 1);
// lib/fp/getDayOfYear.js
var getDayOfYear4 = convertToFP(getDayOfYear, 1);
// lib/fp/getDayOfYearWithOptions.js
var getDayOfYearWithOptions = convertToFP(getDayOfYear, 2);
// lib/fp/getDayWithOptions.js
var getDayWithOptions = convertToFP(getDay, 2);
// lib/getDaysInMonth.js
function getDaysInMonth(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(_date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

// lib/fp/getDaysInMonth.js
var getDaysInMonth3 = convertToFP(getDaysInMonth, 1);
// lib/fp/getDaysInMonthWithOptions.js
var getDaysInMonthWithOptions = convertToFP(getDaysInMonth, 2);
// lib/isLeapYear.js
function isLeapYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// lib/getDaysInYear.js
function getDaysInYear(date, options) {
  const _date = toDate(date, options?.in);
  if (Number.isNaN(+_date))
    return NaN;
  return isLeapYear(_date) ? 366 : 365;
}

// lib/fp/getDaysInYear.js
var getDaysInYear3 = convertToFP(getDaysInYear, 1);
// lib/fp/getDaysInYearWithOptions.js
var getDaysInYearWithOptions = convertToFP(getDaysInYear, 2);
// lib/getDecade.js
function getDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  return decade;
}

// lib/fp/getDecade.js
var getDecade3 = convertToFP(getDecade, 1);
// lib/fp/getDecadeWithOptions.js
var getDecadeWithOptions = convertToFP(getDecade, 2);
// lib/getHours.js
function getHours(date, options) {
  return toDate(date, options?.in).getHours();
}

// lib/fp/getHours.js
var getHours3 = convertToFP(getHours, 1);
// lib/fp/getHoursWithOptions.js
var getHoursWithOptions = convertToFP(getHours, 2);
// lib/getISODay.js
function getISODay(date, options) {
  const day = toDate(date, options?.in).getDay();
  return day === 0 ? 7 : day;
}

// lib/fp/getISODay.js
var getISODay3 = convertToFP(getISODay, 1);
// lib/fp/getISODayWithOptions.js
var getISODayWithOptions = convertToFP(getISODay, 2);
// lib/fp/getISOWeek.js
var getISOWeek4 = convertToFP(getISOWeek, 1);
// lib/fp/getISOWeekWithOptions.js
var getISOWeekWithOptions = convertToFP(getISOWeek, 2);
// lib/fp/getISOWeekYear.js
var getISOWeekYear8 = convertToFP(getISOWeekYear, 1);
// lib/fp/getISOWeekYearWithOptions.js
var getISOWeekYearWithOptions = convertToFP(getISOWeekYear, 2);
// lib/getISOWeeksInYear.js
function getISOWeeksInYear(date, options) {
  const thisYear = startOfISOWeekYear(date, options);
  const nextYear = startOfISOWeekYear(addWeeks(thisYear, 60));
  const diff = +nextYear - +thisYear;
  return Math.round(diff / millisecondsInWeek);
}

// lib/fp/getISOWeeksInYear.js
var getISOWeeksInYear3 = convertToFP(getISOWeeksInYear, 1);
// lib/fp/getISOWeeksInYearWithOptions.js
var getISOWeeksInYearWithOptions = convertToFP(getISOWeeksInYear, 2);
// lib/getMilliseconds.js
function getMilliseconds(date) {
  return toDate(date).getMilliseconds();
}

// lib/fp/getMilliseconds.js
var getMilliseconds3 = convertToFP(getMilliseconds, 1);
// lib/getMinutes.js
function getMinutes(date, options) {
  return toDate(date, options?.in).getMinutes();
}

// lib/fp/getMinutes.js
var getMinutes3 = convertToFP(getMinutes, 1);
// lib/fp/getMinutesWithOptions.js
var getMinutesWithOptions = convertToFP(getMinutes, 2);
// lib/getMonth.js
function getMonth(date, options) {
  return toDate(date, options?.in).getMonth();
}

// lib/fp/getMonth.js
var getMonth3 = convertToFP(getMonth, 1);
// lib/fp/getMonthWithOptions.js
var getMonthWithOptions = convertToFP(getMonth, 2);
// lib/getOverlappingDaysInIntervals.js
function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
  const [leftStart, leftEnd] = [
    +toDate(intervalLeft.start),
    +toDate(intervalLeft.end)
  ].sort((a, b) => a - b);
  const [rightStart, rightEnd] = [
    +toDate(intervalRight.start),
    +toDate(intervalRight.end)
  ].sort((a, b) => a - b);
  const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
  if (!isOverlapping)
    return 0;
  const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
  const left = overlapLeft - getTimezoneOffsetInMilliseconds(overlapLeft);
  const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
  const right = overlapRight - getTimezoneOffsetInMilliseconds(overlapRight);
  return Math.ceil((right - left) / millisecondsInDay);
}

// lib/fp/getOverlappingDaysInIntervals.js
var getOverlappingDaysInIntervals3 = convertToFP(getOverlappingDaysInIntervals, 2);
// lib/fp/getQuarter.js
var getQuarter4 = convertToFP(getQuarter, 1);
// lib/fp/getQuarterWithOptions.js
var getQuarterWithOptions = convertToFP(getQuarter, 2);
// lib/getSeconds.js
function getSeconds(date) {
  return toDate(date).getSeconds();
}

// lib/fp/getSeconds.js
var getSeconds3 = convertToFP(getSeconds, 1);
// lib/getTime.js
function getTime(date) {
  return +toDate(date);
}

// lib/fp/getTime.js
var getTime3 = convertToFP(getTime, 1);
// lib/getUnixTime.js
function getUnixTime(date) {
  return Math.trunc(+toDate(date) / 1000);
}

// lib/fp/getUnixTime.js
var getUnixTime3 = convertToFP(getUnixTime, 1);
// lib/fp/getWeek.js
var getWeek4 = convertToFP(getWeek, 1);
// lib/getWeekOfMonth.js
function getWeekOfMonth(date, options) {
  const defaultOptions12 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions12.weekStartsOn ?? defaultOptions12.locale?.options?.weekStartsOn ?? 0;
  const currentDayOfMonth = getDate(toDate(date, options?.in));
  if (isNaN(currentDayOfMonth))
    return NaN;
  const startWeekDay = getDay(startOfMonth(date, options));
  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0)
    lastDayOfFirstWeek += 7;
  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

// lib/fp/getWeekOfMonth.js
var getWeekOfMonth3 = convertToFP(getWeekOfMonth, 1);
// lib/fp/getWeekOfMonthWithOptions.js
var getWeekOfMonthWithOptions = convertToFP(getWeekOfMonth, 2);
// lib/fp/getWeekWithOptions.js
var getWeekWithOptions = convertToFP(getWeek, 2);
// lib/fp/getWeekYear.js
var getWeekYear5 = convertToFP(getWeekYear, 1);
// lib/fp/getWeekYearWithOptions.js
var getWeekYearWithOptions = convertToFP(getWeekYear, 2);
// lib/lastDayOfMonth.js
function lastDayOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return toDate(_date, options?.in);
}

// lib/getWeeksInMonth.js
function getWeeksInMonth(date, options) {
  const contextDate = toDate(date, options?.in);
  return differenceInCalendarWeeks(lastDayOfMonth(contextDate, options), startOfMonth(contextDate, options), options) + 1;
}

// lib/fp/getWeeksInMonth.js
var getWeeksInMonth3 = convertToFP(getWeeksInMonth, 1);
// lib/fp/getWeeksInMonthWithOptions.js
var getWeeksInMonthWithOptions = convertToFP(getWeeksInMonth, 2);
// lib/getYear.js
function getYear(date, options) {
  return toDate(date, options?.in).getFullYear();
}

// lib/fp/getYear.js
var getYear3 = convertToFP(getYear, 1);
// lib/fp/getYearWithOptions.js
var getYearWithOptions = convertToFP(getYear, 2);
// lib/hoursToMilliseconds.js
function hoursToMilliseconds(hours) {
  return Math.trunc(hours * millisecondsInHour);
}

// lib/fp/hoursToMilliseconds.js
var hoursToMilliseconds3 = convertToFP(hoursToMilliseconds, 1);
// lib/hoursToMinutes.js
function hoursToMinutes(hours) {
  return Math.trunc(hours * minutesInHour);
}

// lib/fp/hoursToMinutes.js
var hoursToMinutes3 = convertToFP(hoursToMinutes, 1);
// lib/hoursToSeconds.js
function hoursToSeconds(hours) {
  return Math.trunc(hours * secondsInHour);
}

// lib/fp/hoursToSeconds.js
var hoursToSeconds3 = convertToFP(hoursToSeconds, 1);
// lib/interval.js
function interval(start, end, options) {
  const [_start, _end] = normalizeDates(options?.in, start, end);
  if (isNaN(+_start))
    throw new TypeError("Start date is invalid");
  if (isNaN(+_end))
    throw new TypeError("End date is invalid");
  if (options?.assertPositive && +_start > +_end)
    throw new TypeError("End date must be after start date");
  return { start: _start, end: _end };
}

// lib/fp/interval.js
var interval3 = convertToFP(interval, 2);
// lib/intervalToDuration.js
function intervalToDuration(interval4, options) {
  const { start, end } = normalizeInterval(options?.in, interval4);
  const duration = {};
  const years = differenceInYears(end, start);
  if (years)
    duration.years = years;
  const remainingMonths = add(start, { years: duration.years });
  const months2 = differenceInMonths(end, remainingMonths);
  if (months2)
    duration.months = months2;
  const remainingDays = add(remainingMonths, { months: duration.months });
  const days2 = differenceInDays(end, remainingDays);
  if (days2)
    duration.days = days2;
  const remainingHours = add(remainingDays, { days: duration.days });
  const hours = differenceInHours(end, remainingHours);
  if (hours)
    duration.hours = hours;
  const remainingMinutes = add(remainingHours, { hours: duration.hours });
  const minutes = differenceInMinutes(end, remainingMinutes);
  if (minutes)
    duration.minutes = minutes;
  const remainingSeconds = add(remainingMinutes, { minutes: duration.minutes });
  const seconds = differenceInSeconds(end, remainingSeconds);
  if (seconds)
    duration.seconds = seconds;
  return duration;
}

// lib/fp/intervalToDuration.js
var intervalToDuration3 = convertToFP(intervalToDuration, 1);
// lib/fp/intervalToDurationWithOptions.js
var intervalToDurationWithOptions = convertToFP(intervalToDuration, 2);
// lib/fp/intervalWithOptions.js
var intervalWithOptions = convertToFP(interval, 3);
// lib/intlFormat.js
function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(toDate(date));
}
function isFormatOptions(opts) {
  return opts !== undefined && !("locale" in opts);
}

// lib/fp/intlFormat.js
var intlFormat3 = convertToFP(intlFormat, 3);
// lib/intlFormatDistance.js
function intlFormatDistance(laterDate, earlierDate, options) {
  let value = 0;
  let unit;
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  if (!options?.unit) {
    const diffInSeconds = differenceInSeconds(laterDate_, earlierDate_);
    if (Math.abs(diffInSeconds) < secondsInMinute) {
      value = differenceInSeconds(laterDate_, earlierDate_);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < secondsInHour) {
      value = differenceInMinutes(laterDate_, earlierDate_);
      unit = "minute";
    } else if (Math.abs(diffInSeconds) < secondsInDay && Math.abs(differenceInCalendarDays(laterDate_, earlierDate_)) < 1) {
      value = differenceInHours(laterDate_, earlierDate_);
      unit = "hour";
    } else if (Math.abs(diffInSeconds) < secondsInWeek && (value = differenceInCalendarDays(laterDate_, earlierDate_)) && Math.abs(value) < 7) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < secondsInMonth) {
      value = differenceInCalendarWeeks(laterDate_, earlierDate_);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < secondsInQuarter) {
      value = differenceInCalendarMonths(laterDate_, earlierDate_);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < secondsInYear) {
      if (differenceInCalendarQuarters(laterDate_, earlierDate_) < 4) {
        value = differenceInCalendarQuarters(laterDate_, earlierDate_);
        unit = "quarter";
      } else {
        value = differenceInCalendarYears(laterDate_, earlierDate_);
        unit = "year";
      }
    } else {
      value = differenceInCalendarYears(laterDate_, earlierDate_);
      unit = "year";
    }
  } else {
    unit = options?.unit;
    if (unit === "second") {
      value = differenceInSeconds(laterDate_, earlierDate_);
    } else if (unit === "minute") {
      value = differenceInMinutes(laterDate_, earlierDate_);
    } else if (unit === "hour") {
      value = differenceInHours(laterDate_, earlierDate_);
    } else if (unit === "day") {
      value = differenceInCalendarDays(laterDate_, earlierDate_);
    } else if (unit === "week") {
      value = differenceInCalendarWeeks(laterDate_, earlierDate_);
    } else if (unit === "month") {
      value = differenceInCalendarMonths(laterDate_, earlierDate_);
    } else if (unit === "quarter") {
      value = differenceInCalendarQuarters(laterDate_, earlierDate_);
    } else if (unit === "year") {
      value = differenceInCalendarYears(laterDate_, earlierDate_);
    }
  }
  const rtf = new Intl.RelativeTimeFormat(options?.locale, {
    numeric: "auto",
    ...options
  });
  return rtf.format(value, unit);
}

// lib/fp/intlFormatDistance.js
var intlFormatDistance3 = convertToFP(intlFormatDistance, 2);
// lib/fp/intlFormatDistanceWithOptions.js
var intlFormatDistanceWithOptions = convertToFP(intlFormatDistance, 3);
// lib/isAfter.js
function isAfter(date, dateToCompare) {
  return +toDate(date) > +toDate(dateToCompare);
}

// lib/fp/isAfter.js
var isAfter3 = convertToFP(isAfter, 2);
// lib/isBefore.js
function isBefore(date, dateToCompare) {
  return +toDate(date) < +toDate(dateToCompare);
}

// lib/fp/isBefore.js
var isBefore3 = convertToFP(isBefore, 2);
// lib/fp/isDate.js
var isDate4 = convertToFP(isDate, 1);
// lib/isEqual.js
function isEqual(leftDate, rightDate) {
  return +toDate(leftDate) === +toDate(rightDate);
}

// lib/fp/isEqual.js
var isEqual3 = convertToFP(isEqual, 2);
// lib/isExists.js
function isExists(year, month, day) {
  const date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

// lib/fp/isExists.js
var isExists3 = convertToFP(isExists, 3);
// lib/isFirstDayOfMonth.js
function isFirstDayOfMonth(date, options) {
  return toDate(date, options?.in).getDate() === 1;
}

// lib/fp/isFirstDayOfMonth.js
var isFirstDayOfMonth3 = convertToFP(isFirstDayOfMonth, 1);
// lib/fp/isFirstDayOfMonthWithOptions.js
var isFirstDayOfMonthWithOptions = convertToFP(isFirstDayOfMonth, 2);
// lib/isFriday.js
function isFriday(date, options) {
  return toDate(date, options?.in).getDay() === 5;
}

// lib/fp/isFriday.js
var isFriday3 = convertToFP(isFriday, 1);
// lib/fp/isFridayWithOptions.js
var isFridayWithOptions = convertToFP(isFriday, 2);
// lib/fp/isLastDayOfMonth.js
var isLastDayOfMonth4 = convertToFP(isLastDayOfMonth, 1);
// lib/fp/isLastDayOfMonthWithOptions.js
var isLastDayOfMonthWithOptions = convertToFP(isLastDayOfMonth, 2);
// lib/fp/isLeapYear.js
var isLeapYear4 = convertToFP(isLeapYear, 1);
// lib/fp/isLeapYearWithOptions.js
var isLeapYearWithOptions = convertToFP(isLeapYear, 2);
// lib/getDefaultOptions.js
function getDefaultOptions2() {
  return Object.assign({}, getDefaultOptions());
}

// lib/transpose.js
function transpose(date, constructor) {
  const date_ = isConstructor(constructor) ? new constructor(0) : constructFrom(constructor, 0);
  date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  return date_;
}
function isConstructor(constructor) {
  return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}

// lib/parse/_lib/Setter.js
var TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;
  validate(_utcDate, _options) {
    return true;
  }
}

class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }
  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}

class DateTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  constructor(context, reference) {
    super();
    this.context = context || ((date) => constructFrom(reference, date));
  }
  set(date, flags) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, transpose(date, this.context));
  }
}

// lib/parse/_lib/Parser.js
class Parser {
  run(dateString, token, match3, options) {
    const result = this.parse(dateString, token, match3, options);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}

// lib/parse/_lib/parsers/EraParser.js
class EraParser extends Parser {
  priority = 140;
  parse(dateString, token, match3) {
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return match3.era(dateString, { width: "abbreviated" }) || match3.era(dateString, { width: "narrow" });
      case "GGGGG":
        return match3.era(dateString, { width: "narrow" });
      case "GGGG":
      default:
        return match3.era(dateString, { width: "wide" }) || match3.era(dateString, { width: "abbreviated" }) || match3.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}

// lib/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

// lib/parse/_lib/utils.js
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// lib/parse/_lib/parsers/YearParser.js
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(dateString, token, match3) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy"
    });
    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = date.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// lib/parse/_lib/parsers/LocalWeekYearParser.js
class LocalWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token, match3) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY"
    });
    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/ISOWeekYearParser.js
class ISOWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/ExtendedYearParser.js
class ExtendedYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}

// lib/parse/_lib/parsers/QuarterParser.js
class QuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match3) {
    switch (token) {
      case "Q":
      case "QQ":
        return parseNDigits(token.length, dateString);
      case "Qo":
        return match3.ordinalNumber(dateString, { unit: "quarter" });
      case "QQQ":
        return match3.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return match3.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/StandAloneQuarterParser.js
class StandAloneQuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match3) {
    switch (token) {
      case "q":
      case "qq":
        return parseNDigits(token.length, dateString);
      case "qo":
        return match3.ordinalNumber(dateString, { unit: "quarter" });
      case "qqq":
        return match3.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return match3.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/MonthParser.js
class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(dateString, token, match3) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "M":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Mo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "MMM":
        return match3.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.month(dateString, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return match3.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return match3.month(dateString, { width: "wide", context: "formatting" }) || match3.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// lib/parse/_lib/parsers/StandAloneMonthParser.js
class StandAloneMonthParser extends Parser {
  priority = 110;
  parse(dateString, token, match3) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "L":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Lo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "LLL":
        return match3.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.month(dateString, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return match3.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return match3.month(dateString, { width: "wide", context: "standalone" }) || match3.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/setWeek.js
function setWeek(date, week, options) {
  const date_ = toDate(date, options?.in);
  const diff = getWeek(date_, options) - week;
  date_.setDate(date_.getDate() - diff * 7);
  return toDate(date_, options?.in);
}

// lib/parse/_lib/parsers/LocalWeekParser.js
class LocalWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match3) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match3.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// lib/setISOWeek.js
function setISOWeek(date, week, options) {
  const _date = toDate(date, options?.in);
  const diff = getISOWeek(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// lib/parse/_lib/parsers/ISOWeekParser.js
class ISOWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match3) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match3.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/DateParser.js
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];

class DateParser extends Parser {
  priority = 90;
  subPriority = 1;
  parse(dateString, token, match3) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match3.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear6 = isLeapYearIndex(year);
    const month = date.getMonth();
    if (isLeapYear6) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/DayOfYearParser.js
class DayOfYearParser extends Parser {
  priority = 90;
  subpriority = 1;
  parse(dateString, token, match3) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match3.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear6 = isLeapYearIndex(year);
    if (isLeapYear6) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/setDay.js
function setDay(date, day, options) {
  const defaultOptions14 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions14.weekStartsOn ?? defaultOptions14.locale?.options?.weekStartsOn ?? 0;
  const date_ = toDate(date, options?.in);
  const currentDay = date_.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(date_, diff, options);
}

// lib/parse/_lib/parsers/DayParser.js
class DayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3) {
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return match3.day(dateString, { width: "wide", context: "formatting" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}

// lib/parse/_lib/parsers/LocalDayParser.js
class LocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "e":
      case "ee":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "eo":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "eee":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "eeeee":
        return match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return match3.day(dateString, { width: "wide", context: "formatting" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, { width: "short", context: "formatting" }) || match3.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/StandAloneLocalDayParser.js
class StandAloneLocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "c":
      case "cc":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "co":
        return mapValue(match3.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "ccc":
        return match3.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
      case "ccccc":
        return match3.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return match3.day(dateString, { width: "wide", context: "standalone" }) || match3.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match3.day(dateString, { width: "short", context: "standalone" }) || match3.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}

// lib/setISODay.js
function setISODay(date, day, options) {
  const date_ = toDate(date, options?.in);
  const currentDay = getISODay(date_, options);
  const diff = day - currentDay;
  return addDays(date_, diff, options);
}

// lib/parse/_lib/parsers/ISODayParser.js
class ISODayParser extends Parser {
  priority = 90;
  parse(dateString, token, match3) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token) {
      case "i":
      case "ii":
        return parseNDigits(token.length, dateString);
      case "io":
        return match3.ordinalNumber(dateString, { unit: "day" });
      case "iii":
        return mapValue(match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiii":
        return mapValue(match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiiii":
        return mapValue(match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiii":
      default:
        return mapValue(match3.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match3.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}

// lib/parse/_lib/parsers/AMPMParser.js
class AMPMParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}

// lib/parse/_lib/parsers/AMPMMidnightParser.js
class AMPMMidnightParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}

// lib/parse/_lib/parsers/DayPeriodParser.js
class DayPeriodParser extends Parser {
  priority = 80;
  parse(dateString, token, match3) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match3.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match3.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}

// lib/parse/_lib/parsers/Hour1to12Parser.js
class Hour1to12Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}

// lib/parse/_lib/parsers/Hour0to23Parser.js
class Hour0to23Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}

// lib/parse/_lib/parsers/Hour0To11Parser.js
class Hour0To11Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}

// lib/parse/_lib/parsers/Hour1To24Parser.js
class Hour1To24Parser extends Parser {
  priority = 70;
  parse(dateString, token, match3) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match3.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}

// lib/parse/_lib/parsers/MinuteParser.js
class MinuteParser extends Parser {
  priority = 60;
  parse(dateString, token, match3) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match3.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// lib/parse/_lib/parsers/SecondParser.js
class SecondParser extends Parser {
  priority = 50;
  parse(dateString, token, match3) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match3.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// lib/parse/_lib/parsers/FractionOfSecondParser.js
class FractionOfSecondParser extends Parser {
  priority = 30;
  parse(dateString, token) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// lib/parse/_lib/parsers/ISOTimezoneWithZParser.js
class ISOTimezoneWithZParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "XXXXX":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "x"];
}

// lib/parse/_lib/parsers/ISOTimezoneParser.js
class ISOTimezoneParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "xxxxx":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "X"];
}

// lib/parse/_lib/parsers/TimestampSecondsParser.js
class TimestampSecondsParser extends Parser {
  priority = 40;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// lib/parse/_lib/parsers/TimestampMillisecondsParser.js
class TimestampMillisecondsParser extends Parser {
  priority = 20;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// lib/parse/_lib/parsers.js
var parsers = {
  G: new EraParser,
  y: new YearParser,
  Y: new LocalWeekYearParser,
  R: new ISOWeekYearParser,
  u: new ExtendedYearParser,
  Q: new QuarterParser,
  q: new StandAloneQuarterParser,
  M: new MonthParser,
  L: new StandAloneMonthParser,
  w: new LocalWeekParser,
  I: new ISOWeekParser,
  d: new DateParser,
  D: new DayOfYearParser,
  E: new DayParser,
  e: new LocalDayParser,
  c: new StandAloneLocalDayParser,
  i: new ISODayParser,
  a: new AMPMParser,
  b: new AMPMMidnightParser,
  B: new DayPeriodParser,
  h: new Hour1to12Parser,
  H: new Hour0to23Parser,
  K: new Hour0To11Parser,
  k: new Hour1To24Parser,
  m: new MinuteParser,
  s: new SecondParser,
  S: new FractionOfSecondParser,
  X: new ISOTimezoneWithZParser,
  x: new ISOTimezoneParser,
  t: new TimestampSecondsParser,
  T: new TimestampMillisecondsParser
};

// lib/parse.js
function parse(dateStr, formatStr, referenceDate, options) {
  const invalidDate = () => constructFrom(options?.in || referenceDate, NaN);
  const defaultOptions14 = getDefaultOptions2();
  const locale = options?.locale ?? defaultOptions14.locale ?? enUS;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions14.firstWeekContainsDate ?? defaultOptions14.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions14.weekStartsOn ?? defaultOptions14.locale?.options?.weekStartsOn ?? 0;
  if (!formatStr)
    return dateStr ? invalidDate() : toDate(referenceDate, options?.in);
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  const setters = [new DateTimezoneSetter(options?.in, referenceDate)];
  const tokens = formatStr.match(longFormattingTokensRegExp2).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp2);
  const usedTokens = [];
  for (let token of tokens) {
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (!options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find((usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
        if (incompatibleToken) {
          throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
      }
      usedTokens.push({ token: firstCharacter, fullToken: token });
      const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
      if (!parseResult) {
        return invalidDate();
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp2)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString2(token);
      }
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return invalidDate();
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return invalidDate();
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a, b) => b - a).filter((priority, index, array) => array.indexOf(priority) === index).map((priority) => setters.filter((setter) => setter.priority === priority).sort((a, b) => b.subPriority - a.subPriority)).map((setterArray) => setterArray[0]);
  let date = toDate(referenceDate, options?.in);
  if (isNaN(+date))
    return invalidDate();
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return invalidDate();
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return date;
}
function cleanEscapedString2(input) {
  return input.match(escapedStringRegExp2)[1].replace(doubleQuoteRegExp2, "'");
}
var formattingTokensRegExp2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp2 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp2 = /[a-zA-Z]/;

// lib/isMatch.js
function isMatch(dateStr, formatStr, options) {
  return isValid(parse(dateStr, formatStr, new Date, options));
}

// lib/fp/isMatch.js
var isMatch3 = convertToFP(isMatch, 2);
// lib/fp/isMatchWithOptions.js
var isMatchWithOptions = convertToFP(isMatch, 3);
// lib/isMonday.js
function isMonday(date, options) {
  return toDate(date, options?.in).getDay() === 1;
}

// lib/fp/isMonday.js
var isMonday3 = convertToFP(isMonday, 1);
// lib/fp/isMondayWithOptions.js
var isMondayWithOptions = convertToFP(isMonday, 2);
// lib/fp/isSameDay.js
var isSameDay4 = convertToFP(isSameDay, 2);
// lib/fp/isSameDayWithOptions.js
var isSameDayWithOptions = convertToFP(isSameDay, 3);
// lib/startOfHour.js
function startOfHour(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMinutes(0, 0, 0);
  return _date;
}

// lib/isSameHour.js
function isSameHour(dateLeft, dateRight, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, dateLeft, dateRight);
  return +startOfHour(dateLeft_) === +startOfHour(dateRight_);
}

// lib/fp/isSameHour.js
var isSameHour3 = convertToFP(isSameHour, 2);
// lib/fp/isSameHourWithOptions.js
var isSameHourWithOptions = convertToFP(isSameHour, 3);
// lib/isSameWeek.js
function isSameWeek(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfWeek(laterDate_, options) === +startOfWeek(earlierDate_, options);
}

// lib/isSameISOWeek.js
function isSameISOWeek(laterDate, earlierDate, options) {
  return isSameWeek(laterDate, earlierDate, { ...options, weekStartsOn: 1 });
}

// lib/fp/isSameISOWeek.js
var isSameISOWeek3 = convertToFP(isSameISOWeek, 2);
// lib/fp/isSameISOWeekWithOptions.js
var isSameISOWeekWithOptions = convertToFP(isSameISOWeek, 3);
// lib/isSameISOWeekYear.js
function isSameISOWeekYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfISOWeekYear(laterDate_) === +startOfISOWeekYear(earlierDate_);
}

// lib/fp/isSameISOWeekYear.js
var isSameISOWeekYear3 = convertToFP(isSameISOWeekYear, 2);
// lib/fp/isSameISOWeekYearWithOptions.js
var isSameISOWeekYearWithOptions = convertToFP(isSameISOWeekYear, 3);
// lib/startOfMinute.js
function startOfMinute(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setSeconds(0, 0);
  return date_;
}

// lib/isSameMinute.js
function isSameMinute(laterDate, earlierDate) {
  return +startOfMinute(laterDate) === +startOfMinute(earlierDate);
}

// lib/fp/isSameMinute.js
var isSameMinute3 = convertToFP(isSameMinute, 2);
// lib/isSameMonth.js
function isSameMonth(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}

// lib/fp/isSameMonth.js
var isSameMonth3 = convertToFP(isSameMonth, 2);
// lib/fp/isSameMonthWithOptions.js
var isSameMonthWithOptions = convertToFP(isSameMonth, 3);
// lib/isSameQuarter.js
function isSameQuarter(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfQuarter(dateLeft_) === +startOfQuarter(dateRight_);
}

// lib/fp/isSameQuarter.js
var isSameQuarter3 = convertToFP(isSameQuarter, 2);
// lib/fp/isSameQuarterWithOptions.js
var isSameQuarterWithOptions = convertToFP(isSameQuarter, 3);
// lib/startOfSecond.js
function startOfSecond(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setMilliseconds(0);
  return date_;
}

// lib/isSameSecond.js
function isSameSecond(laterDate, earlierDate) {
  return +startOfSecond(laterDate) === +startOfSecond(earlierDate);
}

// lib/fp/isSameSecond.js
var isSameSecond3 = convertToFP(isSameSecond, 2);
// lib/fp/isSameWeek.js
var isSameWeek4 = convertToFP(isSameWeek, 2);
// lib/fp/isSameWeekWithOptions.js
var isSameWeekWithOptions = convertToFP(isSameWeek, 3);
// lib/isSameYear.js
function isSameYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() === earlierDate_.getFullYear();
}

// lib/fp/isSameYear.js
var isSameYear3 = convertToFP(isSameYear, 2);
// lib/fp/isSameYearWithOptions.js
var isSameYearWithOptions = convertToFP(isSameYear, 3);
// lib/fp/isSaturday.js
var isSaturday4 = convertToFP(isSaturday, 1);
// lib/fp/isSaturdayWithOptions.js
var isSaturdayWithOptions = convertToFP(isSaturday, 2);
// lib/fp/isSunday.js
var isSunday4 = convertToFP(isSunday, 1);
// lib/fp/isSundayWithOptions.js
var isSundayWithOptions = convertToFP(isSunday, 2);
// lib/isThursday.js
function isThursday(date, options) {
  return toDate(date, options?.in).getDay() === 4;
}

// lib/fp/isThursday.js
var isThursday3 = convertToFP(isThursday, 1);
// lib/fp/isThursdayWithOptions.js
var isThursdayWithOptions = convertToFP(isThursday, 2);
// lib/isTuesday.js
function isTuesday(date, options) {
  return toDate(date, options?.in).getDay() === 2;
}

// lib/fp/isTuesday.js
var isTuesday3 = convertToFP(isTuesday, 1);
// lib/fp/isTuesdayWithOptions.js
var isTuesdayWithOptions = convertToFP(isTuesday, 2);
// lib/fp/isValid.js
var isValid9 = convertToFP(isValid, 1);
// lib/isWednesday.js
function isWednesday(date, options) {
  return toDate(date, options?.in).getDay() === 3;
}

// lib/fp/isWednesday.js
var isWednesday3 = convertToFP(isWednesday, 1);
// lib/fp/isWednesdayWithOptions.js
var isWednesdayWithOptions = convertToFP(isWednesday, 2);
// lib/fp/isWeekend.js
var isWeekend6 = convertToFP(isWeekend, 1);
// lib/fp/isWeekendWithOptions.js
var isWeekendWithOptions = convertToFP(isWeekend, 2);
// lib/isWithinInterval.js
function isWithinInterval(date, interval5, options) {
  const time = +toDate(date, options?.in);
  const [startTime, endTime] = [
    +toDate(interval5.start, options?.in),
    +toDate(interval5.end, options?.in)
  ].sort((a, b) => a - b);
  return time >= startTime && time <= endTime;
}

// lib/fp/isWithinInterval.js
var isWithinInterval3 = convertToFP(isWithinInterval, 2);
// lib/fp/isWithinIntervalWithOptions.js
var isWithinIntervalWithOptions = convertToFP(isWithinInterval, 3);
// lib/lastDayOfDecade.js
function lastDayOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return toDate(_date, options?.in);
}

// lib/fp/lastDayOfDecade.js
var lastDayOfDecade3 = convertToFP(lastDayOfDecade, 1);
// lib/fp/lastDayOfDecadeWithOptions.js
var lastDayOfDecadeWithOptions = convertToFP(lastDayOfDecade, 2);
// lib/lastDayOfWeek.js
function lastDayOfWeek(date, options) {
  const defaultOptions15 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions15.weekStartsOn ?? defaultOptions15.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setHours(0, 0, 0, 0);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

// lib/lastDayOfISOWeek.js
function lastDayOfISOWeek(date, options) {
  return lastDayOfWeek(date, { ...options, weekStartsOn: 1 });
}

// lib/fp/lastDayOfISOWeek.js
var lastDayOfISOWeek3 = convertToFP(lastDayOfISOWeek, 1);
// lib/fp/lastDayOfISOWeekWithOptions.js
var lastDayOfISOWeekWithOptions = convertToFP(lastDayOfISOWeek, 2);
// lib/lastDayOfISOWeekYear.js
function lastDayOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  const date_ = startOfISOWeek(fourthOfJanuary, options);
  date_.setDate(date_.getDate() - 1);
  return date_;
}

// lib/fp/lastDayOfISOWeekYear.js
var lastDayOfISOWeekYear3 = convertToFP(lastDayOfISOWeekYear, 1);
// lib/fp/lastDayOfISOWeekYearWithOptions.js
var lastDayOfISOWeekYearWithOptions = convertToFP(lastDayOfISOWeekYear, 2);
// lib/fp/lastDayOfMonth.js
var lastDayOfMonth4 = convertToFP(lastDayOfMonth, 1);
// lib/fp/lastDayOfMonthWithOptions.js
var lastDayOfMonthWithOptions = convertToFP(lastDayOfMonth, 2);
// lib/lastDayOfQuarter.js
function lastDayOfQuarter(date, options) {
  const date_ = toDate(date, options?.in);
  const currentMonth = date_.getMonth();
  const month = currentMonth - currentMonth % 3 + 3;
  date_.setMonth(month, 0);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// lib/fp/lastDayOfQuarter.js
var lastDayOfQuarter3 = convertToFP(lastDayOfQuarter, 1);
// lib/fp/lastDayOfQuarterWithOptions.js
var lastDayOfQuarterWithOptions = convertToFP(lastDayOfQuarter, 2);
// lib/fp/lastDayOfWeek.js
var lastDayOfWeek4 = convertToFP(lastDayOfWeek, 1);
// lib/fp/lastDayOfWeekWithOptions.js
var lastDayOfWeekWithOptions = convertToFP(lastDayOfWeek, 2);
// lib/lastDayOfYear.js
function lastDayOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  const year = date_.getFullYear();
  date_.setFullYear(year + 1, 0, 0);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// lib/fp/lastDayOfYear.js
var lastDayOfYear3 = convertToFP(lastDayOfYear, 1);
// lib/fp/lastDayOfYearWithOptions.js
var lastDayOfYearWithOptions = convertToFP(lastDayOfYear, 2);
// lib/lightFormat.js
function lightFormat(date, formatStr) {
  const date_ = toDate(date);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const tokens = formatStr.match(formattingTokensRegExp3);
  if (!tokens)
    return "";
  const result = tokens.map((substring) => {
    if (substring === "''") {
      return "'";
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString3(substring);
    }
    const formatter = lightFormatters[firstCharacter];
    if (formatter) {
      return formatter(date_, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp3)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString3(input) {
  const matches = input.match(escapedStringRegExp3);
  if (!matches)
    return input;
  return matches[1].replace(doubleQuoteRegExp3, "'");
}
var formattingTokensRegExp3 = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp3 = /^'([^]*?)'?$/;
var doubleQuoteRegExp3 = /''/g;
var unescapedLatinCharacterRegExp3 = /[a-zA-Z]/;

// lib/fp/lightFormat.js
var lightFormat3 = convertToFP(lightFormat, 2);
// lib/fp/max.js
var max4 = convertToFP(max, 1);
// lib/fp/maxWithOptions.js
var maxWithOptions = convertToFP(max, 2);
// lib/milliseconds.js
function milliseconds({
  years,
  months: months2,
  weeks,
  days: days2,
  hours,
  minutes,
  seconds
}) {
  let totalDays = 0;
  if (years)
    totalDays += years * daysInYear;
  if (months2)
    totalDays += months2 * (daysInYear / 12);
  if (weeks)
    totalDays += weeks * 7;
  if (days2)
    totalDays += days2;
  let totalSeconds = totalDays * 24 * 60 * 60;
  if (hours)
    totalSeconds += hours * 60 * 60;
  if (minutes)
    totalSeconds += minutes * 60;
  if (seconds)
    totalSeconds += seconds;
  return Math.trunc(totalSeconds * 1000);
}

// lib/fp/milliseconds.js
var milliseconds3 = convertToFP(milliseconds, 1);
// lib/millisecondsToHours.js
function millisecondsToHours(milliseconds4) {
  const hours = milliseconds4 / millisecondsInHour;
  return Math.trunc(hours);
}

// lib/fp/millisecondsToHours.js
var millisecondsToHours3 = convertToFP(millisecondsToHours, 1);
// lib/millisecondsToMinutes.js
function millisecondsToMinutes(milliseconds4) {
  const minutes = milliseconds4 / millisecondsInMinute;
  return Math.trunc(minutes);
}

// lib/fp/millisecondsToMinutes.js
var millisecondsToMinutes3 = convertToFP(millisecondsToMinutes, 1);
// lib/millisecondsToSeconds.js
function millisecondsToSeconds(milliseconds4) {
  const seconds = milliseconds4 / millisecondsInSecond;
  return Math.trunc(seconds);
}

// lib/fp/millisecondsToSeconds.js
var millisecondsToSeconds3 = convertToFP(millisecondsToSeconds, 1);
// lib/fp/min.js
var min4 = convertToFP(min, 1);
// lib/fp/minWithOptions.js
var minWithOptions = convertToFP(min, 2);
// lib/minutesToHours.js
function minutesToHours(minutes) {
  const hours = minutes / minutesInHour;
  return Math.trunc(hours);
}

// lib/fp/minutesToHours.js
var minutesToHours3 = convertToFP(minutesToHours, 1);
// lib/minutesToMilliseconds.js
function minutesToMilliseconds(minutes) {
  return Math.trunc(minutes * millisecondsInMinute);
}

// lib/fp/minutesToMilliseconds.js
var minutesToMilliseconds3 = convertToFP(minutesToMilliseconds, 1);
// lib/minutesToSeconds.js
function minutesToSeconds(minutes) {
  return Math.trunc(minutes * secondsInMinute);
}

// lib/fp/minutesToSeconds.js
var minutesToSeconds3 = convertToFP(minutesToSeconds, 1);
// lib/monthsToQuarters.js
function monthsToQuarters(months2) {
  const quarters = months2 / monthsInQuarter;
  return Math.trunc(quarters);
}

// lib/fp/monthsToQuarters.js
var monthsToQuarters3 = convertToFP(monthsToQuarters, 1);
// lib/monthsToYears.js
function monthsToYears(months2) {
  const years = months2 / monthsInYear;
  return Math.trunc(years);
}

// lib/fp/monthsToYears.js
var monthsToYears3 = convertToFP(monthsToYears, 1);
// lib/nextDay.js
function nextDay(date, day, options) {
  let delta = day - getDay(date, options);
  if (delta <= 0)
    delta += 7;
  return addDays(date, delta, options);
}

// lib/fp/nextDay.js
var nextDay3 = convertToFP(nextDay, 2);
// lib/fp/nextDayWithOptions.js
var nextDayWithOptions = convertToFP(nextDay, 3);
// lib/nextFriday.js
function nextFriday(date, options) {
  return nextDay(date, 5, options);
}

// lib/fp/nextFriday.js
var nextFriday3 = convertToFP(nextFriday, 1);
// lib/fp/nextFridayWithOptions.js
var nextFridayWithOptions = convertToFP(nextFriday, 2);
// lib/nextMonday.js
function nextMonday(date, options) {
  return nextDay(date, 1, options);
}

// lib/fp/nextMonday.js
var nextMonday3 = convertToFP(nextMonday, 1);
// lib/fp/nextMondayWithOptions.js
var nextMondayWithOptions = convertToFP(nextMonday, 2);
// lib/nextSaturday.js
function nextSaturday(date, options) {
  return nextDay(date, 6, options);
}

// lib/fp/nextSaturday.js
var nextSaturday3 = convertToFP(nextSaturday, 1);
// lib/fp/nextSaturdayWithOptions.js
var nextSaturdayWithOptions = convertToFP(nextSaturday, 2);
// lib/nextSunday.js
function nextSunday(date, options) {
  return nextDay(date, 0, options);
}

// lib/fp/nextSunday.js
var nextSunday3 = convertToFP(nextSunday, 1);
// lib/fp/nextSundayWithOptions.js
var nextSundayWithOptions = convertToFP(nextSunday, 2);
// lib/nextThursday.js
function nextThursday(date, options) {
  return nextDay(date, 4, options);
}

// lib/fp/nextThursday.js
var nextThursday3 = convertToFP(nextThursday, 1);
// lib/fp/nextThursdayWithOptions.js
var nextThursdayWithOptions = convertToFP(nextThursday, 2);
// lib/nextTuesday.js
function nextTuesday(date, options) {
  return nextDay(date, 2, options);
}

// lib/fp/nextTuesday.js
var nextTuesday3 = convertToFP(nextTuesday, 1);
// lib/fp/nextTuesdayWithOptions.js
var nextTuesdayWithOptions = convertToFP(nextTuesday, 2);
// lib/nextWednesday.js
function nextWednesday(date, options) {
  return nextDay(date, 3, options);
}

// lib/fp/nextWednesday.js
var nextWednesday3 = convertToFP(nextWednesday, 1);
// lib/fp/nextWednesdayWithOptions.js
var nextWednesdayWithOptions = convertToFP(nextWednesday, 2);
// lib/fp/parse.js
var parse4 = convertToFP(parse, 3);
// lib/parseISO.js
function parseISO(argument, options) {
  const invalidDate = () => constructFrom(options?.in, NaN);
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(+date))
    return invalidDate();
  const timestamp = +date;
  let time = 0;
  let offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time))
      return invalidDate();
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset))
      return invalidDate();
  } else {
    const tmpDate = new Date(timestamp + time);
    const result = toDate(0, options?.in);
    result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
    result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
    return result;
  }
  return toDate(timestamp + time + offset, options?.in);
}
function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  const captures = dateString.match(regex);
  if (!captures)
    return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null)
    return new Date(NaN);
  const captures = dateString.match(dateRegex);
  if (!captures)
    return new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures)
    return NaN;
  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z")
    return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures)
    return 0;
  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
function isLeapYearIndex2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex2(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex2(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// lib/fp/parseISO.js
var parseISO3 = convertToFP(parseISO, 1);
// lib/fp/parseISOWithOptions.js
var parseISOWithOptions = convertToFP(parseISO, 2);
// lib/parseJSON.js
function parseJSON(dateStr, options) {
  const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
  if (!parts)
    return toDate(NaN, options?.in);
  return toDate(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)), options?.in);
}

// lib/fp/parseJSON.js
var parseJSON3 = convertToFP(parseJSON, 1);
// lib/fp/parseJSONWithOptions.js
var parseJSONWithOptions = convertToFP(parseJSON, 2);
// lib/fp/parseWithOptions.js
var parseWithOptions = convertToFP(parse, 4);
// lib/subDays.js
function subDays(date, amount, options) {
  return addDays(date, -amount, options);
}

// lib/previousDay.js
function previousDay(date, day, options) {
  let delta = getDay(date, options) - day;
  if (delta <= 0)
    delta += 7;
  return subDays(date, delta, options);
}

// lib/fp/previousDay.js
var previousDay3 = convertToFP(previousDay, 2);
// lib/fp/previousDayWithOptions.js
var previousDayWithOptions = convertToFP(previousDay, 3);
// lib/previousFriday.js
function previousFriday(date, options) {
  return previousDay(date, 5, options);
}

// lib/fp/previousFriday.js
var previousFriday3 = convertToFP(previousFriday, 1);
// lib/fp/previousFridayWithOptions.js
var previousFridayWithOptions = convertToFP(previousFriday, 2);
// lib/previousMonday.js
function previousMonday(date, options) {
  return previousDay(date, 1, options);
}

// lib/fp/previousMonday.js
var previousMonday3 = convertToFP(previousMonday, 1);
// lib/fp/previousMondayWithOptions.js
var previousMondayWithOptions = convertToFP(previousMonday, 2);
// lib/previousSaturday.js
function previousSaturday(date, options) {
  return previousDay(date, 6, options);
}

// lib/fp/previousSaturday.js
var previousSaturday3 = convertToFP(previousSaturday, 1);
// lib/fp/previousSaturdayWithOptions.js
var previousSaturdayWithOptions = convertToFP(previousSaturday, 2);
// lib/previousSunday.js
function previousSunday(date, options) {
  return previousDay(date, 0, options);
}

// lib/fp/previousSunday.js
var previousSunday3 = convertToFP(previousSunday, 1);
// lib/fp/previousSundayWithOptions.js
var previousSundayWithOptions = convertToFP(previousSunday, 2);
// lib/previousThursday.js
function previousThursday(date, options) {
  return previousDay(date, 4, options);
}

// lib/fp/previousThursday.js
var previousThursday3 = convertToFP(previousThursday, 1);
// lib/fp/previousThursdayWithOptions.js
var previousThursdayWithOptions = convertToFP(previousThursday, 2);
// lib/previousTuesday.js
function previousTuesday(date, options) {
  return previousDay(date, 2, options);
}

// lib/fp/previousTuesday.js
var previousTuesday3 = convertToFP(previousTuesday, 1);
// lib/fp/previousTuesdayWithOptions.js
var previousTuesdayWithOptions = convertToFP(previousTuesday, 2);
// lib/previousWednesday.js
function previousWednesday(date, options) {
  return previousDay(date, 3, options);
}

// lib/fp/previousWednesday.js
var previousWednesday3 = convertToFP(previousWednesday, 1);
// lib/fp/previousWednesdayWithOptions.js
var previousWednesdayWithOptions = convertToFP(previousWednesday, 2);
// lib/quartersToMonths.js
function quartersToMonths(quarters) {
  return Math.trunc(quarters * monthsInQuarter);
}

// lib/fp/quartersToMonths.js
var quartersToMonths3 = convertToFP(quartersToMonths, 1);
// lib/quartersToYears.js
function quartersToYears(quarters) {
  const years = quarters / quartersInYear;
  return Math.trunc(years);
}

// lib/fp/quartersToYears.js
var quartersToYears3 = convertToFP(quartersToYears, 1);
// lib/roundToNearestHours.js
function roundToNearestHours(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 12)
    return constructFrom(options?.in || date, NaN);
  const date_ = toDate(date, options?.in);
  const fractionalMinutes = date_.getMinutes() / 60;
  const fractionalSeconds = date_.getSeconds() / 60 / 60;
  const fractionalMilliseconds = date_.getMilliseconds() / 1000 / 60 / 60;
  const hours = date_.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
  date_.setHours(roundedHours, 0, 0, 0);
  return date_;
}

// lib/fp/roundToNearestHours.js
var roundToNearestHours3 = convertToFP(roundToNearestHours, 1);
// lib/fp/roundToNearestHoursWithOptions.js
var roundToNearestHoursWithOptions = convertToFP(roundToNearestHours, 2);
// lib/roundToNearestMinutes.js
function roundToNearestMinutes(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 30)
    return constructFrom(date, NaN);
  const date_ = toDate(date, options?.in);
  const fractionalSeconds = date_.getSeconds() / 60;
  const fractionalMilliseconds = date_.getMilliseconds() / 1000 / 60;
  const minutes = date_.getMinutes() + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  date_.setMinutes(roundedMinutes, 0, 0);
  return date_;
}

// lib/fp/roundToNearestMinutes.js
var roundToNearestMinutes3 = convertToFP(roundToNearestMinutes, 1);
// lib/fp/roundToNearestMinutesWithOptions.js
var roundToNearestMinutesWithOptions = convertToFP(roundToNearestMinutes, 2);
// lib/secondsToHours.js
function secondsToHours(seconds) {
  const hours = seconds / secondsInHour;
  return Math.trunc(hours);
}

// lib/fp/secondsToHours.js
var secondsToHours3 = convertToFP(secondsToHours, 1);
// lib/secondsToMilliseconds.js
function secondsToMilliseconds(seconds) {
  return seconds * millisecondsInSecond;
}

// lib/fp/secondsToMilliseconds.js
var secondsToMilliseconds3 = convertToFP(secondsToMilliseconds, 1);
// lib/secondsToMinutes.js
function secondsToMinutes(seconds) {
  const minutes = seconds / secondsInMinute;
  return Math.trunc(minutes);
}

// lib/fp/secondsToMinutes.js
var secondsToMinutes3 = convertToFP(secondsToMinutes, 1);
// lib/setMonth.js
function setMonth(date, month, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const midMonth = constructFrom(options?.in || date, 0);
  midMonth.setFullYear(year, month, 15);
  midMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(midMonth);
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

// lib/set.js
function set(date, values, options) {
  let _date = toDate(date, options?.in);
  if (isNaN(+_date))
    return constructFrom(options?.in || date, NaN);
  if (values.year != null)
    _date.setFullYear(values.year);
  if (values.month != null)
    _date = setMonth(_date, values.month);
  if (values.date != null)
    _date.setDate(values.date);
  if (values.hours != null)
    _date.setHours(values.hours);
  if (values.minutes != null)
    _date.setMinutes(values.minutes);
  if (values.seconds != null)
    _date.setSeconds(values.seconds);
  if (values.milliseconds != null)
    _date.setMilliseconds(values.milliseconds);
  return _date;
}

// lib/fp/set.js
var set3 = convertToFP(set, 2);
// lib/setDate.js
function setDate(date, dayOfMonth, options) {
  const _date = toDate(date, options?.in);
  _date.setDate(dayOfMonth);
  return _date;
}

// lib/fp/setDate.js
var setDate3 = convertToFP(setDate, 2);
// lib/fp/setDateWithOptions.js
var setDateWithOptions = convertToFP(setDate, 3);
// lib/fp/setDay.js
var setDay6 = convertToFP(setDay, 2);
// lib/setDayOfYear.js
function setDayOfYear(date, dayOfYear, options) {
  const date_ = toDate(date, options?.in);
  date_.setMonth(0);
  date_.setDate(dayOfYear);
  return date_;
}

// lib/fp/setDayOfYear.js
var setDayOfYear3 = convertToFP(setDayOfYear, 2);
// lib/fp/setDayOfYearWithOptions.js
var setDayOfYearWithOptions = convertToFP(setDayOfYear, 3);
// lib/fp/setDayWithOptions.js
var setDayWithOptions = convertToFP(setDay, 3);
// lib/setHours.js
function setHours(date, hours, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(hours);
  return _date;
}

// lib/fp/setHours.js
var setHours3 = convertToFP(setHours, 2);
// lib/fp/setHoursWithOptions.js
var setHoursWithOptions = convertToFP(setHours, 3);
// lib/fp/setISODay.js
var setISODay4 = convertToFP(setISODay, 2);
// lib/fp/setISODayWithOptions.js
var setISODayWithOptions = convertToFP(setISODay, 3);
// lib/fp/setISOWeek.js
var setISOWeek4 = convertToFP(setISOWeek, 2);
// lib/fp/setISOWeekWithOptions.js
var setISOWeekWithOptions = convertToFP(setISOWeek, 3);
// lib/fp/setISOWeekYear.js
var setISOWeekYear4 = convertToFP(setISOWeekYear, 2);
// lib/fp/setISOWeekYearWithOptions.js
var setISOWeekYearWithOptions = convertToFP(setISOWeekYear, 3);
// lib/setMilliseconds.js
function setMilliseconds(date, milliseconds4, options) {
  const _date = toDate(date, options?.in);
  _date.setMilliseconds(milliseconds4);
  return _date;
}

// lib/fp/setMilliseconds.js
var setMilliseconds3 = convertToFP(setMilliseconds, 2);
// lib/fp/setMillisecondsWithOptions.js
var setMillisecondsWithOptions = convertToFP(setMilliseconds, 3);
// lib/setMinutes.js
function setMinutes(date, minutes, options) {
  const date_ = toDate(date, options?.in);
  date_.setMinutes(minutes);
  return date_;
}

// lib/fp/setMinutes.js
var setMinutes3 = convertToFP(setMinutes, 2);
// lib/fp/setMinutesWithOptions.js
var setMinutesWithOptions = convertToFP(setMinutes, 3);
// lib/fp/setMonth.js
var setMonth4 = convertToFP(setMonth, 2);
// lib/fp/setMonthWithOptions.js
var setMonthWithOptions = convertToFP(setMonth, 3);
// lib/setQuarter.js
function setQuarter(date, quarter, options) {
  const date_ = toDate(date, options?.in);
  const oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return setMonth(date_, date_.getMonth() + diff * 3);
}

// lib/fp/setQuarter.js
var setQuarter3 = convertToFP(setQuarter, 2);
// lib/fp/setQuarterWithOptions.js
var setQuarterWithOptions = convertToFP(setQuarter, 3);
// lib/setSeconds.js
function setSeconds(date, seconds, options) {
  const _date = toDate(date, options?.in);
  _date.setSeconds(seconds);
  return _date;
}

// lib/fp/setSeconds.js
var setSeconds3 = convertToFP(setSeconds, 2);
// lib/fp/setSecondsWithOptions.js
var setSecondsWithOptions = convertToFP(setSeconds, 3);
// lib/fp/setWeek.js
var setWeek4 = convertToFP(setWeek, 2);
// lib/fp/setWeekWithOptions.js
var setWeekWithOptions = convertToFP(setWeek, 3);
// lib/setWeekYear.js
function setWeekYear(date, weekYear, options) {
  const defaultOptions16 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions16.firstWeekContainsDate ?? defaultOptions16.locale?.options?.firstWeekContainsDate ?? 1;
  const diff = differenceInCalendarDays(toDate(date, options?.in), startOfWeekYear(date, options), options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const date_ = startOfWeekYear(firstWeek, options);
  date_.setDate(date_.getDate() + diff);
  return date_;
}

// lib/fp/setWeekYear.js
var setWeekYear3 = convertToFP(setWeekYear, 2);
// lib/fp/setWeekYearWithOptions.js
var setWeekYearWithOptions = convertToFP(setWeekYear, 3);
// lib/fp/setWithOptions.js
var setWithOptions = convertToFP(set, 3);
// lib/setYear.js
function setYear(date, year, options) {
  const date_ = toDate(date, options?.in);
  if (isNaN(+date_))
    return constructFrom(options?.in || date, NaN);
  date_.setFullYear(year);
  return date_;
}

// lib/fp/setYear.js
var setYear3 = convertToFP(setYear, 2);
// lib/fp/setYearWithOptions.js
var setYearWithOptions = convertToFP(setYear, 3);
// lib/fp/startOfDay.js
var startOfDay5 = convertToFP(startOfDay, 1);
// lib/fp/startOfDayWithOptions.js
var startOfDayWithOptions = convertToFP(startOfDay, 2);
// lib/startOfDecade.js
function startOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// lib/fp/startOfDecade.js
var startOfDecade3 = convertToFP(startOfDecade, 1);
// lib/fp/startOfDecadeWithOptions.js
var startOfDecadeWithOptions = convertToFP(startOfDecade, 2);
// lib/fp/startOfHour.js
var startOfHour4 = convertToFP(startOfHour, 1);
// lib/fp/startOfHourWithOptions.js
var startOfHourWithOptions = convertToFP(startOfHour, 2);
// lib/fp/startOfISOWeek.js
var startOfISOWeek11 = convertToFP(startOfISOWeek, 1);
// lib/fp/startOfISOWeekWithOptions.js
var startOfISOWeekWithOptions = convertToFP(startOfISOWeek, 2);
// lib/fp/startOfISOWeekYear.js
var startOfISOWeekYear7 = convertToFP(startOfISOWeekYear, 1);
// lib/fp/startOfISOWeekYearWithOptions.js
var startOfISOWeekYearWithOptions = convertToFP(startOfISOWeekYear, 2);
// lib/fp/startOfMinute.js
var startOfMinute4 = convertToFP(startOfMinute, 1);
// lib/fp/startOfMinuteWithOptions.js
var startOfMinuteWithOptions = convertToFP(startOfMinute, 2);
// lib/fp/startOfMonth.js
var startOfMonth6 = convertToFP(startOfMonth, 1);
// lib/fp/startOfMonthWithOptions.js
var startOfMonthWithOptions = convertToFP(startOfMonth, 2);
// lib/fp/startOfQuarter.js
var startOfQuarter5 = convertToFP(startOfQuarter, 1);
// lib/fp/startOfQuarterWithOptions.js
var startOfQuarterWithOptions = convertToFP(startOfQuarter, 2);
// lib/fp/startOfSecond.js
var startOfSecond4 = convertToFP(startOfSecond, 1);
// lib/fp/startOfSecondWithOptions.js
var startOfSecondWithOptions = convertToFP(startOfSecond, 2);
// lib/fp/startOfWeek.js
var startOfWeek12 = convertToFP(startOfWeek, 1);
// lib/fp/startOfWeekWithOptions.js
var startOfWeekWithOptions = convertToFP(startOfWeek, 2);
// lib/fp/startOfWeekYear.js
var startOfWeekYear5 = convertToFP(startOfWeekYear, 1);
// lib/fp/startOfWeekYearWithOptions.js
var startOfWeekYearWithOptions = convertToFP(startOfWeekYear, 2);
// lib/fp/startOfYear.js
var startOfYear5 = convertToFP(startOfYear, 1);
// lib/fp/startOfYearWithOptions.js
var startOfYearWithOptions = convertToFP(startOfYear, 2);
// lib/subMonths.js
function subMonths(date, amount, options) {
  return addMonths(date, -amount, options);
}

// lib/sub.js
function sub(date, duration, options) {
  const {
    years = 0,
    months: months2 = 0,
    weeks = 0,
    days: days2 = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const withoutMonths = subMonths(date, months2 + years * 12, options);
  const withoutDays = subDays(withoutMonths, days2 + weeks * 7, options);
  const minutesToSub = minutes + hours * 60;
  const secondsToSub = seconds + minutesToSub * 60;
  const msToSub = secondsToSub * 1000;
  return constructFrom(options?.in || date, +withoutDays - msToSub);
}

// lib/fp/sub.js
var sub3 = convertToFP(sub, 2);
// lib/subBusinessDays.js
function subBusinessDays(date, amount, options) {
  return addBusinessDays(date, -amount, options);
}

// lib/fp/subBusinessDays.js
var subBusinessDays3 = convertToFP(subBusinessDays, 2);
// lib/fp/subBusinessDaysWithOptions.js
var subBusinessDaysWithOptions = convertToFP(subBusinessDays, 3);
// lib/fp/subDays.js
var subDays5 = convertToFP(subDays, 2);
// lib/fp/subDaysWithOptions.js
var subDaysWithOptions = convertToFP(subDays, 3);
// lib/subHours.js
function subHours(date, amount, options) {
  return addHours(date, -amount, options);
}

// lib/fp/subHours.js
var subHours3 = convertToFP(subHours, 2);
// lib/fp/subHoursWithOptions.js
var subHoursWithOptions = convertToFP(subHours, 3);
// lib/fp/subISOWeekYears.js
var subISOWeekYears4 = convertToFP(subISOWeekYears, 2);
// lib/fp/subISOWeekYearsWithOptions.js
var subISOWeekYearsWithOptions = convertToFP(subISOWeekYears, 3);
// lib/subMilliseconds.js
function subMilliseconds(date, amount, options) {
  return addMilliseconds(date, -amount, options);
}

// lib/fp/subMilliseconds.js
var subMilliseconds3 = convertToFP(subMilliseconds, 2);
// lib/fp/subMillisecondsWithOptions.js
var subMillisecondsWithOptions = convertToFP(subMilliseconds, 3);
// lib/subMinutes.js
function subMinutes(date, amount, options) {
  return addMinutes(date, -amount, options);
}

// lib/fp/subMinutes.js
var subMinutes3 = convertToFP(subMinutes, 2);
// lib/fp/subMinutesWithOptions.js
var subMinutesWithOptions = convertToFP(subMinutes, 3);
// lib/fp/subMonths.js
var subMonths4 = convertToFP(subMonths, 2);
// lib/fp/subMonthsWithOptions.js
var subMonthsWithOptions = convertToFP(subMonths, 3);
// lib/subQuarters.js
function subQuarters(date, amount, options) {
  return addQuarters(date, -amount, options);
}

// lib/fp/subQuarters.js
var subQuarters3 = convertToFP(subQuarters, 2);
// lib/fp/subQuartersWithOptions.js
var subQuartersWithOptions = convertToFP(subQuarters, 3);
// lib/subSeconds.js
function subSeconds(date, amount, options) {
  return addSeconds(date, -amount, options);
}

// lib/fp/subSeconds.js
var subSeconds3 = convertToFP(subSeconds, 2);
// lib/fp/subSecondsWithOptions.js
var subSecondsWithOptions = convertToFP(subSeconds, 3);
// lib/subWeeks.js
function subWeeks(date, amount, options) {
  return addWeeks(date, -amount, options);
}

// lib/fp/subWeeks.js
var subWeeks3 = convertToFP(subWeeks, 2);
// lib/fp/subWeeksWithOptions.js
var subWeeksWithOptions = convertToFP(subWeeks, 3);
// lib/fp/subWithOptions.js
var subWithOptions = convertToFP(sub, 3);
// lib/subYears.js
function subYears(date, amount, options) {
  return addYears(date, -amount, options);
}

// lib/fp/subYears.js
var subYears3 = convertToFP(subYears, 2);
// lib/fp/subYearsWithOptions.js
var subYearsWithOptions = convertToFP(subYears, 3);
// lib/fp/toDate.js
var toDate108 = convertToFP(toDate, 2);
// lib/fp/transpose.js
var transpose4 = convertToFP(transpose, 2);
// lib/weeksToDays.js
function weeksToDays(weeks) {
  return Math.trunc(weeks * daysInWeek);
}

// lib/fp/weeksToDays.js
var weeksToDays3 = convertToFP(weeksToDays, 1);
// lib/yearsToDays.js
function yearsToDays(years) {
  return Math.trunc(years * daysInYear);
}

// lib/fp/yearsToDays.js
var yearsToDays3 = convertToFP(yearsToDays, 1);
// lib/yearsToMonths.js
function yearsToMonths(years) {
  return Math.trunc(years * monthsInYear);
}

// lib/fp/yearsToMonths.js
var yearsToMonths3 = convertToFP(yearsToMonths, 1);
// lib/yearsToQuarters.js
function yearsToQuarters(years) {
  return Math.trunc(years * quartersInYear);
}

// lib/fp/yearsToQuarters.js
var yearsToQuarters3 = convertToFP(yearsToQuarters, 1);
// lib/fp/cdn.js
window.dateFns = {
  ...window.dateFns,
  fp: exports_fp
};

//# debugId=A843AFEAAC00B90864756E2164756E21
